import hc from "../img/specialities/hc.png";
import geo from "../img/specialities/geo.png";
import re from "../img/specialities/re.png";

export const branches = [
  {
    speciality: "Hydrocarbons",
    id: 0,
    year_of_study: [
      {
        name: "Licence",
        years: [
          {
            name: "First year",
            branches: [{ name: "Common year", link: "#" }],
            id: "0",
          },
          {
            name: "Second year",
            branches: [
              { name: "Production professional", link: "#" },
              { name: "Production academic", link: "#" },
              { name: "Drilling", link: "#" },
              { name: "Oil Rig Mechanics", link: "#" },
            ],
            id: "1",
          },
          {
            name: "Third year",
            branches: [
              { name: "Production professional", link: "#" },
              { name: "Production academic", link: "#" },
              { name: "Drilling", link: "#" },
              { name: "Oil Rig Mechanics", link: "#" },
            ],
            id: "2",
          },
        ],
      },
      {
        name: "Master",
        years: [
          {
            name: "First year",
            branches: [
              { name: "Production professional", link: "#" },
              { name: "Production academic", link: "#" },
              { name: "Drilling", link: "#" },
              { name: "Oil Rig Mechanics", link: "#" },
            ],
            id: "0",
          },
          {
            name: "Second year",
            branches: [
              { name: "Production professional", link: "#" },
              { name: "Production academic", link: "#" },
              { name: "Drilling", link: "#" },
              { name: "Oil Rig Mechanics", link: "#" },
            ],
            id: "1",
          },
        ],
      },
    ],
  },
  {
    speciality: "Geology",
    id: 1,
    year_of_study: [
      {
        name: "Licence",
        years: [
          {
            name: "First year",
            branches: [{ name: "Common year", link: "#" }],
            id: "0",
          },
          {
            name: "Second year",
            branches: [{ name: "Common year", link: "#" }],
            id: "1",
          },
          {
            name: "Third year",
            branches: [
              {
                name: "Fundamental geology stratigraphy sedimentology",
                link: "#",
              },
              { name: "Hydrocarbon geology", link: "#" },
              { name: "Hydrogeology", link: "#" },
              { name: "Petroleum geology", link: "#" },
            ],
            id: "2",
          },
        ],
      },
      {
        name: "Master",
        years: [
          {
            name: "First year",
            branches: [
              { name: "Sedimentary Basin Geology", link: "#" },
              { name: "Geology Of Hydrocarbons", link: "#" },
              { name: "Hydrogeology", link: "#" },
              { name: "Petroleum Geology", link: "#" },
            ],
            id: "0",
          },
          {
            name: "Second year",
            branches: [
              { name: "Sedimentary Basin Geology", link: "#" },
              { name: "Geology Of Hydrocarbons", link: "#" },
              { name: "Hydrogeology", link: "#" },
              { name: "Petroleum Geology", link: "#" },
            ],
            id: "1",
          },
        ],
      },
    ],
  },
  {
    speciality: "Renewable Energies",
    id: 2,
    year_of_study: [
      {
        name: "Licence",
        years: [
          {
            name: "First year",
            branches: [{ name: "Common year", link: "#" }],
            id: "0",
          },
          {
            name: "Second year",
            branches: [{ name: "Applied Renewable Energy", link: "#" }],
            id: "1",
          },
          {
            name: "Third year",
            branches: [{ name: "Applied Renewable Energy", link: "#" }],
            id: "2",
          },
        ],
      },
      {
        name: "Master",
        years: [
          {
            name: "First year",
            branches: [{ name: "Renewable Energy in Mechanics", link: "#" }],
            id: "0",
          },
          {
            name: "Second year",
            branches: [{ name: "Renewable Energy in Mechanics", link: "#" }],
            id: "1",
          },
        ],
      },
    ],
  },
];

export const specialities = [
  {
    name: "Hydrocarbons",
    id: 0,
    bg: hc,
    text: "A field of engineering concerned exploration and production of Hydrocarbons",
    link: "#",
    svg: "M0,256L48,261.3C96,267,192,277,288,288C384,299,480,309,576,293.3C672,277,768,235,864,224C960,213,1056,235,1152,218.7C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
  },
  {
    name: "Geology",
    id: 1,
    bg: geo,
    text: "A science that deals with the history of the earth and its life especially as recorded in rocks",
    link: "#",
    svg: "M0,192L120,208C240,224,480,256,720,272C960,288,1200,288,1320,288L1440,288L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z",
  },
  {
    name: "Renewable_Energies",
    id: 2,
    bg: re,
    text: "An engineering field that focuses on the production of energy from renewable or sustainable sources",
    link: "#",
    svg: "M0,256L1440,160L1440,320L0,320Z",
  },
];
export const files = {
  hydrocarbons: {
    licence: {
      first_year: {
        common_year: [
          {
            key: "1IaYpTXeMHb8MT43z0w3py8Vfrpd7VG9a",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1LAmkC950Wt3jeRN-aUla_EzdRkj_CXgc",
                gd_id: "1LAmkC950Wt3jeRN-aUla_EzdRkj_CXgc",
                label: "langue francaise 1",
                nodes: [],
              },
              {
                key: "1LGagdActkbbVEXwJnLdPhpMmb1MXlNQ7",
                gd_id: "1LGagdActkbbVEXwJnLdPhpMmb1MXlNQ7",
                label: "langue anglaise 1",
                nodes: [],
              },
              {
                key: "1KpDIJ8KQ6yYhd6Ky6CxZQORoOyfzGftQ",
                gd_id: "1KpDIJ8KQ6yYhd6Ky6CxZQORoOyfzGftQ",
                label: "TP physique 1",
                nodes: [],
              },
              {
                key: "1KpVT3q20m2qD0tT0UFxc1qKTmC0_aCZH",
                gd_id: "1KpVT3q20m2qD0tT0UFxc1qKTmC0_aCZH",
                label: "TP chimie 1",
                nodes: [],
              },
              {
                key: "1KwLaxeJEkWPpkoACj5Tu0_XJfwjsXqUi",
                gd_id: "1KwLaxeJEkWPpkoACj5Tu0_XJfwjsXqUi",
                label: "Structure de la matière",
                nodes: [],
              },
              {
                key: "1L68RZ9O9A5EPuwRZN8J-YzTGcS2IUNu-",
                gd_id: "1L68RZ9O9A5EPuwRZN8J-YzTGcS2IUNu-",
                label: "Méthodologie de la rédaction",
                nodes: [],
              },
              {
                key: "1L9Cg3G8FLCyF7d1BfaH4jZTtBtMG6ykv",
                gd_id: "1L9Cg3G8FLCyF7d1BfaH4jZTtBtMG6ykv",
                label: "les métiers en sciences et technologies 1",
                nodes: [],
              },
              {
                key: "1L3o3Rl68gXc9Tr_eTy70yrNNonRAsFsB",
                gd_id: "1L3o3Rl68gXc9Tr_eTy70yrNNonRAsFsB",
                label: "Physique 1",
                nodes: [],
              },
              {
                key: "1L72oI73xvmSwX3Rcm7dewY0ImTeFII0R",
                gd_id: "1L72oI73xvmSwX3Rcm7dewY0ImTeFII0R",
                label: "Mathématiques 1",
                nodes: [],
              },
              {
                key: "1LIh1jMkSkA2a6GYeHLDAvxrGovmK4G5X",
                gd_id: "1LIh1jMkSkA2a6GYeHLDAvxrGovmK4G5X",
                label: "Informatique 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1IV68TIoAuo1vJr06Uzf1-DODUD5MJeHm",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1KMzC1KEEWASd5t47FHRlkw_xgpPY2AOg",
                gd_id: "1KMzC1KEEWASd5t47FHRlkw_xgpPY2AOg",
                label: "les métiers en sciences et technologies 2",
                nodes: [],
              },
              {
                key: "1KNI7_y8GcIw1pFuxPq6Rpdf0Kp6CWIUS",
                gd_id: "1KNI7_y8GcIw1pFuxPq6Rpdf0Kp6CWIUS",
                label: "langue francaise 2",
                nodes: [],
              },
              {
                key: "1KcGTj2cMfej3IqspjxvrVPVnLGZzxnX7",
                gd_id: "1KcGTj2cMfej3IqspjxvrVPVnLGZzxnX7",
                label: "langue anglaise 2",
                nodes: [],
              },
              {
                key: "1KHj0DOdcSz_bPCxRvGL3obR6k8Qeq6Mz",
                gd_id: "1KHj0DOdcSz_bPCxRvGL3obR6k8Qeq6Mz",
                label: "mathématique 2",
                nodes: [],
              },
              {
                key: "1Kg54uYQVSgpYEPAEm3VJR0Hz5YazIFkq",
                gd_id: "1Kg54uYQVSgpYEPAEm3VJR0Hz5YazIFkq",
                label: "informatique 2",
                nodes: [],
              },
              {
                key: "1M6K3ZyPCqONQB9diYC3TSSSyAxD4u_5n",
                gd_id: "1M6K3ZyPCqONQB9diYC3TSSSyAxD4u_5n",
                label: "thermodynamique",
                nodes: [],
              },
              {
                key: "1M84d7LOT9uefGOOztzurgUockDN72kK7",
                gd_id: "1M84d7LOT9uefGOOztzurgUockDN72kK7",
                label: "méthodologie de la présentation",
                nodes: [],
              },
              {
                key: "1LoRQfXBXPfuX2bnE0x6Xah8HFOWnEijp",
                gd_id: "1LoRQfXBXPfuX2bnE0x6Xah8HFOWnEijp",
                label: "TP physique 2",
                nodes: [],
              },
              {
                key: "1LypYjrncqECBQJFzFHwzkm2gbshk5YIZ",
                gd_id: "1LypYjrncqECBQJFzFHwzkm2gbshk5YIZ",
                label: "TP chimie 2",
                nodes: [],
              },
              {
                key: "1M7Ge1GH1wGIF_fMT9RSrNP7sfqgsi__d",
                gd_id: "1M7Ge1GH1wGIF_fMT9RSrNP7sfqgsi__d",
                label: "physique 2",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        production_professional: [
          {
            key: "1IFPokj0eK78bP00CiqGp-UMH_NrM2kGQ",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1OEi-khkCZnLxQ-3ay-pXxjUKCi8yfSiX",
                gd_id: "1OEi-khkCZnLxQ-3ay-pXxjUKCi8yfSiX",
                label: "Anglais Technique",
                nodes: [],
              },
              {
                key: "1NsrKNJYntvhbaG6W9fZggwvxnV9-iqzm",
                gd_id: "1NsrKNJYntvhbaG6W9fZggwvxnV9-iqzm",
                label: "TP Géologie Générale",
                nodes: [],
              },
              {
                key: "1NwVh2R4kn-uysKn727oREwu7bN1lIRKZ",
                gd_id: "1NwVh2R4kn-uysKn727oREwu7bN1lIRKZ",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1O1O260_AZkBiA_kQcP7_aSNZRcjQ9XFo",
                gd_id: "1O1O260_AZkBiA_kQcP7_aSNZRcjQ9XFo",
                label: "Méthodes Numériques Appliquées 1",
                nodes: [],
              },
              {
                key: "1O49JpUXO0I572j1vi-gAi1hBkCg7GIuA",
                gd_id: "1O49JpUXO0I572j1vi-gAi1hBkCg7GIuA",
                label: "HSE Installations Industrielles",
                nodes: [],
              },
              {
                key: "1PiXxwMj49l7coZ9_YdJ25ogoJWp57MVC",
                gd_id: "1PiXxwMj49l7coZ9_YdJ25ogoJWp57MVC",
                label: "TP Thermodynamique",
                nodes: [],
              },
              {
                key: "1O4UXTdpA2b5a3LXvH5o7a1-yrF9EBsuM",
                gd_id: "1O4UXTdpA2b5a3LXvH5o7a1-yrF9EBsuM",
                label: "Géologie Générale",
                nodes: [],
              },
              {
                key: "1O4laZbdZ4FhHoEwUFMk91mJYH1VXGbjf",
                gd_id: "1O4laZbdZ4FhHoEwUFMk91mJYH1VXGbjf",
                label: "Forage des Puits",
                nodes: [],
              },
              {
                key: "1O0SkWksgg6fZECk8mt0neJQ0AV8f-r_N",
                gd_id: "1O0SkWksgg6fZECk8mt0neJQ0AV8f-r_N",
                label: "Production 1",
                nodes: [],
              },
              {
                key: "1O4dJO4wHqwxQzxkDzOS65IioCeJ70nYm",
                gd_id: "1O4dJO4wHqwxQzxkDzOS65IioCeJ70nYm",
                label: "Gisement",
                nodes: [],
              },
            ],
          },
          {
            key: "1I7-Donp9j-QiLBkrgwGYRIWsS4B9FZaZ",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1PC1lwCYM5r3wOTOYHzbS7wZh8TAJfp_P",
                gd_id: "1PC1lwCYM5r3wOTOYHzbS7wZh8TAJfp_P",
                label: "Sortie scientifique",
                nodes: [],
              },
              {
                key: "1PFKzeC8wNqCFZ-Of1ewaEhXtKo-ZkBGH",
                gd_id: "1PFKzeC8wNqCFZ-Of1ewaEhXtKo-ZkBGH",
                label: "Notions des phénomènes de transfert",
                nodes: [],
              },
              {
                key: "1P2LuvpmSJLkx4oDHQo3aKiXdzdoNyu-r",
                gd_id: "1P2LuvpmSJLkx4oDHQo3aKiXdzdoNyu-r",
                label: "TP Production",
                nodes: [],
              },
              {
                key: "1P5jNGv7X7bTiOOTte8uuHJiLALCrw_HQ",
                gd_id: "1P5jNGv7X7bTiOOTte8uuHJiLALCrw_HQ",
                label: "TP MDF",
                nodes: [],
              },
              {
                key: "1PKLqxCxhjWjhCfrB6SmcEPXWPBPMUUkn",
                gd_id: "1PKLqxCxhjWjhCfrB6SmcEPXWPBPMUUkn",
                label: "Hydrogéologie",
                nodes: [],
              },
              {
                key: "1PiC6e3Lm9CgoY5LK78UTttPCLb8QH71y",
                gd_id: "1PiC6e3Lm9CgoY5LK78UTttPCLb8QH71y",
                label: "Dessin Technique",
                nodes: [],
              },
              {
                key: "1POssfGCegGhm5bf_ghB1itCI-qFWNEF0",
                gd_id: "1POssfGCegGhm5bf_ghB1itCI-qFWNEF0",
                label: "Géologie pétrolière",
                nodes: [],
              },
              {
                key: "1PRfTyD1EBTHNWuyBasKQSaBMASUIA8Mc",
                gd_id: "1PRfTyD1EBTHNWuyBasKQSaBMASUIA8Mc",
                label: "Equipement de production",
                nodes: [],
              },
              {
                key: "1P1mYLQ1nzmDDyawDwI5K0hD6V5DVrc4F",
                gd_id: "1P1mYLQ1nzmDDyawDwI5K0hD6V5DVrc4F",
                label: "Well intervention 1",
                nodes: [],
              },
              {
                key: "1PHQzcjH77fE0jEdJvK40h10QcHGHOpGX",
                gd_id: "1PHQzcjH77fE0jEdJvK40h10QcHGHOpGX",
                label: "MDF",
                nodes: [],
              },
              {
                key: "1PCbvz4voWaKZG9mUf3rruCi09Oa9tw-S",
                gd_id: "1PCbvz4voWaKZG9mUf3rruCi09Oa9tw-S",
                label: "Production 2",
                nodes: [],
              },
            ],
          },
        ],
        production_academic: [
          {
            key: "1IPRtpIkQ1yBhFSRNdWyHkh1v69dyR7pH",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1LKPkY0A_2otWnV3UYm0SOjin9V09OWid",
                gd_id: "1LKPkY0A_2otWnV3UYm0SOjin9V09OWid",
                label: "Réglementation et Normes",
                nodes: [],
              },
              {
                key: "1LayWmxsmH-KyaO4St0JjLLYkylO2YrPM",
                gd_id: "1LayWmxsmH-KyaO4St0JjLLYkylO2YrPM",
                label: "HSE Installations Industrielles",
                nodes: [],
              },
              {
                key: "1LdIGqR-9pUaNJb2FMnLV6wOYxyv8eDfc",
                gd_id: "1LdIGqR-9pUaNJb2FMnLV6wOYxyv8eDfc",
                label: "Dessin Technique",
                nodes: [],
              },
              {
                key: "1Lo662npPEVltA1w94MgA3063XK8Qhb6A",
                gd_id: "1Lo662npPEVltA1w94MgA3063XK8Qhb6A",
                label: "Anglais Technique",
                nodes: [],
              },
              {
                key: "1Ms9fue-tWNWQujTxQ03P-h5hP7f5WHCH",
                gd_id: "1Ms9fue-tWNWQujTxQ03P-h5hP7f5WHCH",
                label: "TP Ondes et Vibrations",
                nodes: [],
              },
              {
                key: "1LMp_1TCrpGjopID4gZsbN6ZO-jljdpYF",
                gd_id: "1LMp_1TCrpGjopID4gZsbN6ZO-jljdpYF",
                label: "Probabilités & statistique",
                nodes: [],
              },
              {
                key: "1LRlhHwjxroz2n1diTXXk1Ezi9e_uqJII",
                gd_id: "1LRlhHwjxroz2n1diTXXk1Ezi9e_uqJII",
                label: "MDF",
                nodes: [],
              },
              {
                key: "1LamQdQOGdxepZ0uH74wnad3qdlf4Roqn",
                gd_id: "1LamQdQOGdxepZ0uH74wnad3qdlf4Roqn",
                label: "Informatique 3",
                nodes: [],
              },
              {
                key: "1Lh3Crv8PQ7ihy8HFHUdKlnq0nZ9y6hk6",
                gd_id: "1Lh3Crv8PQ7ihy8HFHUdKlnq0nZ9y6hk6",
                label: "Chimie Minérale",
                nodes: [],
              },
              {
                key: "1LNn7mkAfNM4yYFiaOXTz2Q1PGpj0_U6_",
                gd_id: "1LNn7mkAfNM4yYFiaOXTz2Q1PGpj0_U6_",
                label: "Ondes & Vibrations",
                nodes: [],
              },
              {
                key: "1LRndMjEOhnLNFYwWivD1_dIRNjSA6N6l",
                gd_id: "1LRndMjEOhnLNFYwWivD1_dIRNjSA6N6l",
                label: "Mathématiques 3",
                nodes: [],
              },
            ],
          },
          {
            key: "1ILOhZr61DwsdSh60d53Iw0ntGj8qiN8p",
            gd_id: "",
            label: "Second semester",
            nodes: [],
          },
        ],
        drilling: [
          {
            key: "1IKs4bJSAXmBJLyv1iF8-JdDEhITLD0Zv",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1MJPkZU2bLLLOK9DL3Kp40oJqSKLY3d7v",
                gd_id: "1MJPkZU2bLLLOK9DL3Kp40oJqSKLY3d7v",
                label: "TP Pompe et compresseur",
                nodes: [],
              },
              {
                key: "1MO80X583k8tTJMhRcLp5CKkPNuQuAsVz",
                gd_id: "1MO80X583k8tTJMhRcLp5CKkPNuQuAsVz",
                label: "TP Hydraulique",
                nodes: [],
              },
              {
                key: "1MUbUcEEneqIthvqfjmwYsjDgbR4Wwwl1",
                gd_id: "1MUbUcEEneqIthvqfjmwYsjDgbR4Wwwl1",
                label: "TP Géologie",
                nodes: [],
              },
              {
                key: "1MrqHskAbOjKuorQDjptH1ceYhJdNGyUC",
                gd_id: "1MrqHskAbOjKuorQDjptH1ceYhJdNGyUC",
                label: "Dessin technique",
                nodes: [],
              },
              {
                key: "1M_WHzRo7ur_VcS0M77KmEK7Q7yQ7bqa3",
                gd_id: "1M_WHzRo7ur_VcS0M77KmEK7Q7yQ7bqa3",
                label: "Mécanique des fluides",
                nodes: [],
              },
              {
                key: "1Mb22QRYESBlBTOjhO2BHULdEeVCHuKtn",
                gd_id: "1Mb22QRYESBlBTOjhO2BHULdEeVCHuKtn",
                label: "Géologie générale",
                nodes: [],
              },
              {
                key: "1MbLCM12z1jV0sfISdHmbAzZduWrpZY6i",
                gd_id: "1MbLCM12z1jV0sfISdHmbAzZduWrpZY6i",
                label: "Forage 1",
                nodes: [],
              },
              {
                key: "1MgK7vZYIz8Vif7eit8wauWqeWaTTrKTK",
                gd_id: "1MgK7vZYIz8Vif7eit8wauWqeWaTTrKTK",
                label: "Fluide de forage",
                nodes: [],
              },
              {
                key: "1Mm8V7V7aD9ta1pbI2U1A-XfyWRizaaZz",
                gd_id: "1Mm8V7V7aD9ta1pbI2U1A-XfyWRizaaZz",
                label: "Equipement de forage 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1IKXLnptBZnk3DMikdloRPMEOrzVFXhnY",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1M8Cwb-Ln4XvFHeQPwf8q-02hpLimLQEy",
                gd_id: "1M8Cwb-Ln4XvFHeQPwf8q-02hpLimLQEy",
                label: "Sécurité industrielle",
                nodes: [],
              },
              {
                key: "1NcFprcIaoWm5AJpVlvY_O-oeG2CWuKqW",
                gd_id: "1NcFprcIaoWm5AJpVlvY_O-oeG2CWuKqW",
                label: "TP Thermodynamique",
                nodes: [],
              },
              {
                key: "1NfZAFfeMdyjrLsSSaVnpL_xJYV5Zp55X",
                gd_id: "1NfZAFfeMdyjrLsSSaVnpL_xJYV5Zp55X",
                label: "TP Equipements électriques",
                nodes: [],
              },
              {
                key: "1NqlQh_GtT6ZY8-BYYmEWAiwex2aFbj4S",
                gd_id: "1NqlQh_GtT6ZY8-BYYmEWAiwex2aFbj4S",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1MCngue4pxC5-khXZxXERI34DZnajewq8",
                gd_id: "1MCngue4pxC5-khXZxXERI34DZnajewq8",
                label: "Géologie pétrolière",
                nodes: [],
              },
              {
                key: "1MD4_T9isBOl_FNX0n7yjbLXNeKUoFgB5",
                gd_id: "1MD4_T9isBOl_FNX0n7yjbLXNeKUoFgB5",
                label: "Equipements électriques",
                nodes: [],
              },
              {
                key: "1MEMUgdSQrvhMOlpMh6pxe7DLi0vWn44f",
                gd_id: "1MEMUgdSQrvhMOlpMh6pxe7DLi0vWn44f",
                label: "Equipement de forage 2",
                nodes: [],
              },
              {
                key: "1MD3DnDrNTxrN_10QUx4Kl12bjXYHZYNG",
                gd_id: "1MD3DnDrNTxrN_10QUx4Kl12bjXYHZYNG",
                label: "forage 2",
                nodes: [],
              },
            ],
          },
        ],
        oil_rig_mechanics: [
          {
            key: "1IIUMp0rV1z3gtxxl23VYL56a0qsYMhmd",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1N_FzjqmgbTvPxFQQNJ4ImEVrlGsX2sZs",
                gd_id: "1N_FzjqmgbTvPxFQQNJ4ImEVrlGsX2sZs",
                label: "Dessin technique",
                nodes: [],
              },
              {
                key: "1NHZK4XE-I7G78w5jA1CqCtuB4_zaV2vo",
                gd_id: "1NHZK4XE-I7G78w5jA1CqCtuB4_zaV2vo",
                label: "TP Thermodynamique",
                nodes: [],
              },
              {
                key: "1NHhHBWqIxdUM9QWXvFvqxIGECTzqqVPu",
                gd_id: "1NHhHBWqIxdUM9QWXvFvqxIGECTzqqVPu",
                label: "TP Fabrication mécanique 1",
                nodes: [],
              },
              {
                key: "1NNste-YCtQuvoDxsOhYv5jU0yM3MojqZ",
                gd_id: "1NNste-YCtQuvoDxsOhYv5jU0yM3MojqZ",
                label: "Fabrication mécanique",
                nodes: [],
              },
              {
                key: "1NJCj6jRa_GStxgxgIpjOfL08wfYqv1ez",
                gd_id: "1NJCj6jRa_GStxgxgIpjOfL08wfYqv1ez",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1NKgJCC8ZuhpZmFhozQroFX-dCRSld9ob",
                gd_id: "1NKgJCC8ZuhpZmFhozQroFX-dCRSld9ob",
                label: "Forage",
                nodes: [],
              },
              {
                key: "1NRfEKPXIXYVtzifQNnxLMivFomqaD1DT",
                gd_id: "1NRfEKPXIXYVtzifQNnxLMivFomqaD1DT",
                label: "Equipement de production 1",
                nodes: [],
              },
              {
                key: "1NYk5I52PcGIQksBEtLj2qXHH6Qkr_G5L",
                gd_id: "1NYk5I52PcGIQksBEtLj2qXHH6Qkr_G5L",
                label: "Electrotechnique",
                nodes: [],
              },
              {
                key: "1NRmQ-AOTUALpXMF7KbskNsNixbQ1ocPF",
                gd_id: "1NRmQ-AOTUALpXMF7KbskNsNixbQ1ocPF",
                label: "Equipement de forage 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1IGN192PIYL78oKVbrN_K5zXm9w6u4_ZG",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1ORmGV4dApvnZmvJMy70wn9LovmW5ZuEq",
                gd_id: "1ORmGV4dApvnZmvJMy70wn9LovmW5ZuEq",
                label: "TP Fabrication mécanique 2",
                nodes: [],
              },
              {
                key: "1OZztZACy9f1NJs9klNQ6VxLVf7z8aMmA",
                gd_id: "1OZztZACy9f1NJs9klNQ6VxLVf7z8aMmA",
                label: "TP Equipements électrique",
                nodes: [],
              },
              {
                key: "1OdafNBnIRqGH2G5ef0aclGQaDSzn5ZGR",
                gd_id: "1OdafNBnIRqGH2G5ef0aclGQaDSzn5ZGR",
                label: "Sécurité Industrielle",
                nodes: [],
              },
              {
                key: "1OeufRTc5Q6-J5an5Id9yQ0KQp-OB6Y7Z",
                gd_id: "1OeufRTc5Q6-J5an5Id9yQ0KQp-OB6Y7Z",
                label: "Fabrication mécanique 2",
                nodes: [],
              },
              {
                key: "1N3uDT_z0Y9nODOMwPrROpy4UJ2KeL6rF",
                gd_id: "1N3uDT_z0Y9nODOMwPrROpy4UJ2KeL6rF",
                label: "Equipement électrique",
                nodes: [],
              },
              {
                key: "1NDkVpXL6n775OJsKpg3CAlIwqRYqLvvO",
                gd_id: "1NDkVpXL6n775OJsKpg3CAlIwqRYqLvvO",
                label: "Equipement de Production 2",
                nodes: [],
              },
              {
                key: "1OGlf1oVR8HPx6ViU0Ft6fFzefygQ_ORH",
                gd_id: "1OGlf1oVR8HPx6ViU0Ft6fFzefygQ_ORH",
                label: "Éléments machine",
                nodes: [],
              },
              {
                key: "1OLBROHrR0jDlqQBfAjT9pXIFp959Y7xF",
                gd_id: "1OLBROHrR0jDlqQBfAjT9pXIFp959Y7xF",
                label: "Transfert Thermique",
                nodes: [],
              },
              {
                key: "1NFTO_YINJpmt3xkvYqtZM9SGF8kuY42H",
                gd_id: "1NFTO_YINJpmt3xkvYqtZM9SGF8kuY42H",
                label: "Equipement de forage 2",
                nodes: [],
              },
            ],
          },
        ],
      },
      third_year: {
        production_professional: [
          {
            key: "1JBAE-P3hdtPreORCwYB-rJJJn-J4uMbc",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1TW9yODKu71ZU2dv_x8i9wABJS197FW5d",
                gd_id: "1TW9yODKu71ZU2dv_x8i9wABJS197FW5d",
                label: "Well Intervention",
                nodes: [],
              },
              {
                key: "1ThFDIzAZiSCIaGnesRo9VIqYkxa5sjdF",
                gd_id: "1ThFDIzAZiSCIaGnesRo9VIqYkxa5sjdF",
                label: "TP Pompes et Compresseurs",
                nodes: [],
              },
              {
                key: "1SBVu5j0BtQOhGjYLg3IqVX3wSPm1kz02",
                gd_id: "1SBVu5j0BtQOhGjYLg3IqVX3wSPm1kz02",
                label: "TP Informatique",
                nodes: [],
              },
              {
                key: "1JP7b1cp0FqVWIRPKpqflTnyUhZbNS-_4",
                gd_id: "1JP7b1cp0FqVWIRPKpqflTnyUhZbNS-_4",
                label: "TP Diagraphie de Production",
                nodes: [],
              },
              {
                key: "1JPAxs3PqrIXU8UWPkprdLqxxlBl4DV6h",
                gd_id: "1JPAxs3PqrIXU8UWPkprdLqxxlBl4DV6h",
                label: "Science des Matériaux",
                nodes: [],
              },
              {
                key: "1JRsNJ66NXGbQmMflSrxzdblYefUo2H_C",
                gd_id: "1JRsNJ66NXGbQmMflSrxzdblYefUo2H_C",
                label: "Production de Pétrole",
                nodes: [],
              },
              {
                key: "1JVR7lqlmZ1_iRdUfAT4S__WQ4vWPyxrA",
                gd_id: "1JVR7lqlmZ1_iRdUfAT4S__WQ4vWPyxrA",
                label: "Pompes et Compresseurs",
                nodes: [],
              },
              {
                key: "1JaNblwUCyUDPCnLGfLhP4AOGjUQY-ujK",
                gd_id: "1JaNblwUCyUDPCnLGfLhP4AOGjUQY-ujK",
                label: "Economie des Entreprises",
                nodes: [],
              },
              {
                key: "1JdsbyYSJXzjkjGMKCV6zuIaIIn6iw_z6",
                gd_id: "1JdsbyYSJXzjkjGMKCV6zuIaIIn6iw_z6",
                label: "Diagraphie Différée et de Production",
                nodes: [],
              },
              {
                key: "1JkVAkdhlRggPFDJNecSQjcaYzGJe5btw",
                gd_id: "1JkVAkdhlRggPFDJNecSQjcaYzGJe5btw",
                label: "Collecte et Séparation 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1J7AwFmVlaElJyju-0U6yRhmpRAuInjOL",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1TQi3E5BKm1Rwu2QmN269do5qTADDrthH",
                gd_id: "1TQi3E5BKm1Rwu2QmN269do5qTADDrthH",
                label: "Législation des hydrocarbures",
                nodes: [],
              },
              {
                key: "1TD0PcHIDph_D3qL5LRAotWrxnMFA7nfZ",
                gd_id: "1TD0PcHIDph_D3qL5LRAotWrxnMFA7nfZ",
                label: "TP régulation automatique",
                nodes: [],
              },
              {
                key: "1TGW-jE9gEVcjI2WyFFWDKVzLjevl8mVw",
                gd_id: "1TGW-jE9gEVcjI2WyFFWDKVzLjevl8mVw",
                label: "Résistance des matériaux",
                nodes: [],
              },
              {
                key: "1TGzrdImUHnNjFA9cfJ1P-Yy--I5DBM__",
                gd_id: "1TGzrdImUHnNjFA9cfJ1P-Yy--I5DBM__",
                label: "Régulation automatique",
                nodes: [],
              },
              {
                key: "1TL9IYmGckr_5_7PIue-T0_uKdznLdUgw",
                gd_id: "1TL9IYmGckr_5_7PIue-T0_uKdznLdUgw",
                label: "Production du gaz",
                nodes: [],
              },
              {
                key: "1TLVu8qFirCzck2YQX8YRWiIxBi3jw-Uc",
                gd_id: "1TLVu8qFirCzck2YQX8YRWiIxBi3jw-Uc",
                label: "Mémoire de fin d’étude",
                nodes: [],
              },
              {
                key: "1TUwkAEtgDYESohtCU08HMoJLtDflVUq9",
                gd_id: "1TUwkAEtgDYESohtCU08HMoJLtDflVUq9",
                label: "Collecte et séparation 2",
                nodes: [],
              },
              {
                key: "1TQ2L8_DJwsftqhscwyyUX5j7-Cz8zp5p",
                gd_id: "1TQ2L8_DJwsftqhscwyyUX5j7-Cz8zp5p",
                label: "Mud logging",
                nodes: [],
              },
            ],
          },
        ],
        production_academic: [
          {
            key: "1I6IQTtEXRB8qNh25fSYqOLqD-hAHNMAk",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1P0yT6orASKQPn5S0OV1eyuDP1dGf2oqX",
                gd_id: "1P0yT6orASKQPn5S0OV1eyuDP1dGf2oqX",
                label: "Economie des Entreprises",
                nodes: [],
              },
              {
                key: "1OqG4FpdIkznow84GvWS0mESAmmkeZxLK",
                gd_id: "1OqG4FpdIkznow84GvWS0mESAmmkeZxLK",
                label: "Energies Renouvelables",
                nodes: [],
              },
              {
                key: "1QBlsgS0qQygLi9PdtlPbGrx1-a-_UuV5",
                gd_id: "1QBlsgS0qQygLi9PdtlPbGrx1-a-_UuV5",
                label: "TP Thermodynamique",
                nodes: [],
              },
              {
                key: "1QIU2mOb8YHNaQjrMmo9r248qTbfjBrEW",
                gd_id: "1QIU2mOb8YHNaQjrMmo9r248qTbfjBrEW",
                label: "TP PVT",
                nodes: [],
              },
              {
                key: "1QJpPliaBpyzfK_i8UWOjEULPspXy74kp",
                gd_id: "1QJpPliaBpyzfK_i8UWOjEULPspXy74kp",
                label: "TP Production 2",
                nodes: [],
              },
              {
                key: "1QMP0BJGhBE1P7ppqtCUcw_WIgINkESAj",
                gd_id: "1QMP0BJGhBE1P7ppqtCUcw_WIgINkESAj",
                label: "Pompes et Compresseurs",
                nodes: [],
              },
              {
                key: "1OoreIdnQt3ouuUijtZyMYMa2ZR8ZsBhu",
                gd_id: "1OoreIdnQt3ouuUijtZyMYMa2ZR8ZsBhu",
                label: "Forage 1",
                nodes: [],
              },
              {
                key: "1QKg-7F_z2GgdzDyy8Zyf-ubpMEkmOTVN",
                gd_id: "1QKg-7F_z2GgdzDyy8Zyf-ubpMEkmOTVN",
                label: "Thermodynamique 1",
                nodes: [],
              },
              {
                key: "1QLPR3gRsqwhZtIBKLmXPPprt5oYoSd1y",
                gd_id: "1QLPR3gRsqwhZtIBKLmXPPprt5oYoSd1y",
                label: "Propriétés des Fluides du Réservoir",
                nodes: [],
              },
              {
                key: "1QYEWtl-YrxtRRaS6t37Es3wWUYzWMKMK",
                gd_id: "1QYEWtl-YrxtRRaS6t37Es3wWUYzWMKMK",
                label: "Géologie Pétrolière",
                nodes: [],
              },
            ],
          },
          {
            key: "1I3kNbsAbMg3NhbTzr6ubApUbqh_Lwlx8",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1PpSWKOFLMdBLHCeGiZ175xGP-iNA0zfA",
                gd_id: "1PpSWKOFLMdBLHCeGiZ175xGP-iNA0zfA",
                label: "TP Pétro physiques",
                nodes: [],
              },
              {
                key: "1Q9qif7drDh0efYtOw5LhaAb_-6phb5Kj",
                gd_id: "1Q9qif7drDh0efYtOw5LhaAb_-6phb5Kj",
                label: "Législation des Hydrocarbures",
                nodes: [],
              },
              {
                key: "1RphbOeKyULnZkME6UZG0HUdDGvWggH2O",
                gd_id: "1RphbOeKyULnZkME6UZG0HUdDGvWggH2O",
                label: "Transport des Hydrocarbures",
                nodes: [],
              },
              {
                key: "1RxsRECC6EP-DwR98EVTuFW9lToHYm1z6",
                gd_id: "1RxsRECC6EP-DwR98EVTuFW9lToHYm1z6",
                label: "TP Régulation automatique",
                nodes: [],
              },
              {
                key: "1PsGTHkuzB4QOA76lwB-wt15Q7kVxiO4J",
                gd_id: "1PsGTHkuzB4QOA76lwB-wt15Q7kVxiO4J",
                label: "Thermodynamique 2",
                nodes: [],
              },
              {
                key: "1PwEihblFul2-GeOoWoDepp69qJhfbBya",
                gd_id: "1PwEihblFul2-GeOoWoDepp69qJhfbBya",
                label: "Régulation automatique",
                nodes: [],
              },
              {
                key: "1Q5FsZKSIDFmzoqR3y2la8owC1OtjfwFA",
                gd_id: "1Q5FsZKSIDFmzoqR3y2la8owC1OtjfwFA",
                label: "Mémoire fin d’étude",
                nodes: [],
              },
              {
                key: "1QBQxG3-edOPyz42zoMqt5P8OSa-PBXYl",
                gd_id: "1QBQxG3-edOPyz42zoMqt5P8OSa-PBXYl",
                label: "Diagraphie de production",
                nodes: [],
              },
              {
                key: "1PyRsqZMiXnZX2ps8ZHrTcl0KxSxdBuge",
                gd_id: "1PyRsqZMiXnZX2ps8ZHrTcl0KxSxdBuge",
                label: "Production du gaz",
                nodes: [],
              },
              {
                key: "1Q4U7520XMPc2LXIjqAVErAy8aH6Gq7JC",
                gd_id: "1Q4U7520XMPc2LXIjqAVErAy8aH6Gq7JC",
                label: "Production 2",
                nodes: [],
              },
            ],
          },
        ],
        drilling: [
          {
            key: "1I3CEFk0iDZh_Z8545nLng1TPAYV1Z-ji",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1QwHc3Ma2UItwfhy_lYi0n90DCTK7o1z2",
                gd_id: "1QwHc3Ma2UItwfhy_lYi0n90DCTK7o1z2",
                label: "TP Informatique",
                nodes: [],
              },
              {
                key: "1RCxR062Vhtwc5p3xrq2YIBGQQmI2EM3O",
                gd_id: "1RCxR062Vhtwc5p3xrq2YIBGQQmI2EM3O",
                label: "TP Diagraphie",
                nodes: [],
              },
              {
                key: "1Rcz1Ii-sNFzH3T0MR5aIDfmxyumEHOLM",
                gd_id: "1Rcz1Ii-sNFzH3T0MR5aIDfmxyumEHOLM",
                label: "Etude technique (mini projet)",
                nodes: [],
              },
              {
                key: "1Rjroj4gvouKsELO8XI29yYkW03Oas5x7",
                gd_id: "1Rjroj4gvouKsELO8XI29yYkW03Oas5x7",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1RNFSEkS68ZI8yTnPCUImf9UNm_HN0HeI",
                gd_id: "1RNFSEkS68ZI8yTnPCUImf9UNm_HN0HeI",
                label: "Production et gisement",
                nodes: [],
              },
              {
                key: "1RRNwfGMIKXt5hQSnOQJ3_oi5nY8MfJ-m",
                gd_id: "1RRNwfGMIKXt5hQSnOQJ3_oi5nY8MfJ-m",
                label: "Pompes et compresseurs",
                nodes: [],
              },
              {
                key: "1RhhHu_dhSri4mW7l2XxTvI9zAG8rGYoQ",
                gd_id: "1RhhHu_dhSri4mW7l2XxTvI9zAG8rGYoQ",
                label: "Diagraphie",
                nodes: [],
              },
              {
                key: "1RY_YEK6AuBGQe0DDhtP05aDz6AwqwM1_",
                gd_id: "1RY_YEK6AuBGQe0DDhtP05aDz6AwqwM1_",
                label: "Forage 3",
                nodes: [],
              },
              {
                key: "1RahjMY4PtknS4KVQkI6aGZWMnAufmUpm",
                gd_id: "1RahjMY4PtknS4KVQkI6aGZWMnAufmUpm",
                label: "Fluides et ciment",
                nodes: [],
              },
            ],
          },
          {
            key: "1I-pVZvTLLABwfcQfYkJFu3Bc6rYfJdfi",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1QkrqHzCKFxfpaoRGFxzmvvGd8nSU7Ngw",
                gd_id: "1QkrqHzCKFxfpaoRGFxzmvvGd8nSU7Ngw",
                label: "Equipements et Entretien des puits",
                nodes: [],
              },
              {
                key: "1SvdHH0hfAc2IQKXJYNrkUyUXOOHM1qfh",
                gd_id: "1SvdHH0hfAc2IQKXJYNrkUyUXOOHM1qfh",
                label: "Maintenance des puits",
                nodes: [],
              },
              {
                key: "1Qlh2Yp0d-wqZpjLZe7MfkhPIg2Zt1cvO",
                gd_id: "1Qlh2Yp0d-wqZpjLZe7MfkhPIg2Zt1cvO",
                label: "Economie des hydrocarbures",
                nodes: [],
              },
              {
                key: "1SmWEDwSptopIUaDVcYRWDFRH5lP7Zy6k",
                gd_id: "1SmWEDwSptopIUaDVcYRWDFRH5lP7Zy6k",
                label: "TP Régulation automatique",
                nodes: [],
              },
              {
                key: "1Spr45yZ5XsNyH5N_5-MMIiVN92brXkjY",
                gd_id: "1Spr45yZ5XsNyH5N_5-MMIiVN92brXkjY",
                label: "TP informatique",
                nodes: [],
              },
              {
                key: "1QgIgm8_qhEhpGRbyLU1GVC5NZrJY41Xe",
                gd_id: "1QgIgm8_qhEhpGRbyLU1GVC5NZrJY41Xe",
                label: "Législation de travail",
                nodes: [],
              },
              {
                key: "1SvH1gG0idXzQYIxnzmrfR_8Ia-h725DX",
                gd_id: "1SvH1gG0idXzQYIxnzmrfR_8Ia-h725DX",
                label: "Régulation automatique",
                nodes: [],
              },
              {
                key: "1QuUQVpFqwbhSWm5pbK_YXkIdo-hhJcSz",
                gd_id: "1QuUQVpFqwbhSWm5pbK_YXkIdo-hhJcSz",
                label: "Controle des éruptions",
                nodes: [],
              },
            ],
          },
        ],
        oil_rig_mechanics: [
          {
            key: "1HnWzHhrjXKcFvf2SiXHK3mLX8BaEofuA",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1SIDQNnGhV0ZqGw3OxilECrZzlRpyU1pN",
                gd_id: "1SIDQNnGhV0ZqGw3OxilECrZzlRpyU1pN",
                label: "TP Moteur thermique",
                nodes: [],
              },
              {
                key: "1SITgLRd8YbXjqDcYh4T583lNEfdKLFwO",
                gd_id: "1SITgLRd8YbXjqDcYh4T583lNEfdKLFwO",
                label: "TP Informatique",
                nodes: [],
              },
              {
                key: "1SVByyr6S0UreHaog2oA4EYjdNoc-6qAm",
                gd_id: "1SVByyr6S0UreHaog2oA4EYjdNoc-6qAm",
                label: "Etude technique (mini projet)",
                nodes: [],
              },
              {
                key: "1SXC078xKRry9-ckoLJl0KTonMGnsxbzs",
                gd_id: "1SXC078xKRry9-ckoLJl0KTonMGnsxbzs",
                label: "Eléments de machines 02",
                nodes: [],
              },
              {
                key: "1SjWD0Q50OfB70PzOFrIfiO2WWd8kLq6_",
                gd_id: "1SjWD0Q50OfB70PzOFrIfiO2WWd8kLq6_",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1SJorIfxHViT7pv6Q5sZ_4gMVh90qikod",
                gd_id: "1SJorIfxHViT7pv6Q5sZ_4gMVh90qikod",
                label: "Pompes et compresseurs 1",
                nodes: [],
              },
              {
                key: "1SMOC6TM-skxLQZ17lYeGwWcftc-UwT2W",
                gd_id: "1SMOC6TM-skxLQZ17lYeGwWcftc-UwT2W",
                label: "Maintenance - Appareils statiques et dynamiques",
                nodes: [],
              },
              {
                key: "1Sh0mLcQ7OuT-shnCiKS1SG-GlpZhGHm2",
                gd_id: "1Sh0mLcQ7OuT-shnCiKS1SG-GlpZhGHm2",
                label: "Corrosion et protection",
                nodes: [],
              },
              {
                key: "1ShVAfiLCpHBRxEFqkCQOmZHqTBlH-kP-",
                gd_id: "1ShVAfiLCpHBRxEFqkCQOmZHqTBlH-kP-",
                label: "Bureau études et méthodes",
                nodes: [],
              },
              {
                key: "1SLh_Z7PqK6H1CNwPzKhqT3JjaxJcHU4j",
                gd_id: "1SLh_Z7PqK6H1CNwPzKhqT3JjaxJcHU4j",
                label: "Moteur thermique et conversion d'énergie 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1JEOZ6COcSLMIt-V-kQ5Bas07qAGAZoEr",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1Jz0vCDl7XrGWFyKOrHzp5DJRtm0xf6TK",
                gd_id: "1Jz0vCDl7XrGWFyKOrHzp5DJRtm0xf6TK",
                label: "TP Pompe et Compresseur",
                nodes: [],
              },
              {
                key: "1JzxFz1i-St_wpp_j1Ul-rHTo7J1Felcr",
                gd_id: "1JzxFz1i-St_wpp_j1Ul-rHTo7J1Felcr",
                label: "TP Informatique",
                nodes: [],
              },
              {
                key: "1KBzu4GqYqBQf6LlaHOk_hXXJhnkfH4Ih",
                gd_id: "1KBzu4GqYqBQf6LlaHOk_hXXJhnkfH4Ih",
                label: "Législation de travail",
                nodes: [],
              },
              {
                key: "1KHYl_48PhjdRgBqeoWiNcBRcTmqqVpzV",
                gd_id: "1KHYl_48PhjdRgBqeoWiNcBRcTmqqVpzV",
                label: "Economie des hydrocarbures",
                nodes: [],
              },
              {
                key: "1K-H7Mp-cppHSHVxfSM8uy5sIcUfolLav",
                gd_id: "1K-H7Mp-cppHSHVxfSM8uy5sIcUfolLav",
                label: "Régulation automatique",
                nodes: [],
              },
              {
                key: "1K0RGVUvS93wZC_6_aSyeEGRns16bC4HC",
                gd_id: "1K0RGVUvS93wZC_6_aSyeEGRns16bC4HC",
                label: "Pompe et Compresseur",
                nodes: [],
              },
              {
                key: "1K3CsWD7Yagn1FYWCCoMSm6sRzzlLSAk5",
                gd_id: "1K3CsWD7Yagn1FYWCCoMSm6sRzzlLSAk5",
                label: "Moteur thermique",
                nodes: [],
              },
              {
                key: "1K4Hxn-gwh0z74B7iV6RVFAOAjpe5GjIX",
                gd_id: "1K4Hxn-gwh0z74B7iV6RVFAOAjpe5GjIX",
                label: "Maintenance des équipements pétroliers",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
    master: {
      first_year: {
        production_professional: [
          {
            key: "1Vho4rYGmY6OK7Ru8y7T8JMBSz6Fh2fyG",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1_IVQe8Ht61LyoUeS2xMYcY532yghMgO3",
                gd_id: "1_IVQe8Ht61LyoUeS2xMYcY532yghMgO3",
                label: "Mécanique des Fluides en Milieu Poreux",
                nodes: [],
              },
              {
                key: "1_KmkVYJwPjsiklj54nNe5yjoBZbM7jfv",
                gd_id: "1_KmkVYJwPjsiklj54nNe5yjoBZbM7jfv",
                label: "Anglais Appliquées",
                nodes: [],
              },
              {
                key: "1_40YylqXqXqMps2vE6pJcaZbqrNyQQ2o",
                gd_id: "1_40YylqXqXqMps2vE6pJcaZbqrNyQQ2o",
                label: "Techniques Avancées de Forage et Complétion",
                nodes: [],
              },
              {
                key: "1_5t9yHXF8T9WFitw3kin4gBonGMGZGFh",
                gd_id: "1_5t9yHXF8T9WFitw3kin4gBonGMGZGFh",
                label: "Simulation Numérique en Réservoir Engineering",
                nodes: [],
              },
              {
                key: "1_8kNHh1ds_yCLEx3B-apezYSanWqeGJQ",
                gd_id: "1_8kNHh1ds_yCLEx3B-apezYSanWqeGJQ",
                label: "Réservoir Engineering",
                nodes: [],
              },
              {
                key: "1_Cg7sVMl-km7mnDFzKzsBEsQA0UYetOv",
                gd_id: "1_Cg7sVMl-km7mnDFzKzsBEsQA0UYetOv",
                label: "Pétrophysiques et Diagraphie de Pétrole",
                nodes: [],
              },
              {
                key: "1_EEoAj-SkJjwij9DNTFtp0uTypcKhXT2",
                gd_id: "1_EEoAj-SkJjwij9DNTFtp0uTypcKhXT2",
                label: "Méthodes Numériques Appliquées 2",
                nodes: [],
              },
            ],
          },
          {
            key: "1Wi8bQNX_RI3a4nVEOz8QbEkeC9EMcsWG",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1YzqXrTSNnbEPvilAceTW1dtHG6MiLEMr",
                gd_id: "1YzqXrTSNnbEPvilAceTW1dtHG6MiLEMr",
                label: "Turbomachines",
                nodes: [],
              },
              {
                key: "1Z9mzJneC0RT8zS3L86u0sTNX4gTqk_Ex",
                gd_id: "1Z9mzJneC0RT8zS3L86u0sTNX4gTqk_Ex",
                label: "Chimie de surface",
                nodes: [],
              },
              {
                key: "1ZCKTmx9ypu0pyPDoziBBnRfFVsniTnki",
                gd_id: "1ZCKTmx9ypu0pyPDoziBBnRfFVsniTnki",
                label: "Audit énergétique, Energie, enjeux et perspective",
                nodes: [],
              },
              {
                key: "1Z3TSwU8VUQdyZYklqAQW3PBKxCPw-Aiu",
                gd_id: "1Z3TSwU8VUQdyZYklqAQW3PBKxCPw-Aiu",
                label: "Transfert de chaleur et de masse",
                nodes: [],
              },
              {
                key: "1Z5bVVUVe5XJGlNJOlcJ9Hns0eWzYDlxM",
                gd_id: "1Z5bVVUVe5XJGlNJOlcJ9Hns0eWzYDlxM",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1Z7uO1jCVxnVayA8ggypQhlTJ4Peu88bC",
                gd_id: "1Z7uO1jCVxnVayA8ggypQhlTJ4Peu88bC",
                label: "PVT",
                nodes: [],
              },
              {
                key: "1Z9Lg1TQCBvGyEFJkGcXFjj0UELeqSjVc",
                gd_id: "1Z9Lg1TQCBvGyEFJkGcXFjj0UELeqSjVc",
                label: "Production du pétrole et du gaz",
                nodes: [],
              },
            ],
          },
        ],
        production_academic: [
          {
            key: "1J20e8u_gCNaDKCKBTaaNQS8xw7u9QS-A",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1SywNln3OA8tjWvfwrwC8UEsWUSSWy4af",
                gd_id: "1SywNln3OA8tjWvfwrwC8UEsWUSSWy4af",
                label: "Mécanique de Fluide en Milieux Poreux",
                nodes: [],
              },
              {
                key: "1T-Mwkbbj1kv9xT4E6RMgOFHASop8y_R2",
                gd_id: "1T-Mwkbbj1kv9xT4E6RMgOFHASop8y_R2",
                label: "Forage 2",
                nodes: [],
              },
              {
                key: "1T3GcgNnERwpbMgpXPBxbtGd5xZ3aX-OD",
                gd_id: "1T3GcgNnERwpbMgpXPBxbtGd5xZ3aX-OD",
                label: "Communication Ecrite et Orale",
                nodes: [],
              },
              {
                key: "1Uqdd_GdB19rFsa2p7ZEoEZ_rL2SWysyO",
                gd_id: "1Uqdd_GdB19rFsa2p7ZEoEZ_rL2SWysyO",
                label: "Simulation Numérique en Réservoir Engineering",
                nodes: [],
              },
              {
                key: "1Swgna756Div61WGz5_J6pZnyJ06qGdkk",
                gd_id: "1Swgna756Div61WGz5_J6pZnyJ06qGdkk",
                label: "PVT",
                nodes: [],
              },
              {
                key: "1SwuCMpGu8YOa_w1yG2PoeJndjacV7Gv6",
                gd_id: "1SwuCMpGu8YOa_w1yG2PoeJndjacV7Gv6",
                label: "Méthodes Numériques Appliquées 2",
                nodes: [],
              },
              {
                key: "1Ushcac9Q3LNExQrDuMY_otKPTfZUV_ez",
                gd_id: "1Ushcac9Q3LNExQrDuMY_otKPTfZUV_ez",
                label: "Réservoir Engineering",
                nodes: [],
              },
              {
                key: "1Ui4cbU-W9G5_aTnMkKy5rpd-ugJjbwgl",
                gd_id: "1Ui4cbU-W9G5_aTnMkKy5rpd-ugJjbwgl",
                label: "Tests des Puits",
                nodes: [],
              },
            ],
          },
          {
            key: "1J1uv6P5WD4BybcISmQAwCZCeVa4-i_EA",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1UP3Yd7qoQ6qitljyhQ2Vvk29F-yghl1v",
                gd_id: "1UP3Yd7qoQ6qitljyhQ2Vvk29F-yghl1v",
                label: "Chimie de surface",
                nodes: [],
              },
              {
                key: "1UfBPaFqzI2AMRwjtTh-VM83IHsFa6pes",
                gd_id: "1UfBPaFqzI2AMRwjtTh-VM83IHsFa6pes",
                label: "Audit énergétique, Energie, enjeux et perspective",
                nodes: [],
              },
              {
                key: "1U67M-RNGFwlsqLDjVBYG4bad81rkZgpV",
                gd_id: "1U67M-RNGFwlsqLDjVBYG4bad81rkZgpV",
                label: "Écoulement Polyphasique et Analyse Nodal",
                nodes: [],
              },
              {
                key: "1U7KrtNmY1AhIOIfnPEqY3lMiEmJhIRHh",
                gd_id: "1U7KrtNmY1AhIOIfnPEqY3lMiEmJhIRHh",
                label: "Turbomachines",
                nodes: [],
              },
              {
                key: "1UAdt90Yr3-A91pfJSJwCyBm3pFmKadCN",
                gd_id: "1UAdt90Yr3-A91pfJSJwCyBm3pFmKadCN",
                label: "Transfert de chaleur et de masse",
                nodes: [],
              },
              {
                key: "1ULhU5u8YT89SfJzexJlEn1sJMC-SrIk3",
                gd_id: "1ULhU5u8YT89SfJzexJlEn1sJMC-SrIk3",
                label: "Pétro physique et diagraphie",
                nodes: [],
              },
              {
                key: "1UDDl_eWU9nzwQ6rvl8L6EXPN6PBsav8m",
                gd_id: "1UDDl_eWU9nzwQ6rvl8L6EXPN6PBsav8m",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1UDmCwq1hUDIgPBIHTnB3v54lDJHyQYHx",
                gd_id: "1UDmCwq1hUDIgPBIHTnB3v54lDJHyQYHx",
                label: "Techniques avancées de forage et complétion",
                nodes: [],
              },
              {
                key: "1UORAxn5Sdqu9LUl4uBaKW-Y6vZvLEJyv",
                gd_id: "1UORAxn5Sdqu9LUl4uBaKW-Y6vZvLEJyv",
                label: "Production de pétrole et du gaz",
                nodes: [],
              },
            ],
          },
        ],
        drilling: [
          {
            key: "1J19Ui62qQVCx8QrDka04nFEe07-Ck-zm",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1VgVyfZ7rWVi5JUytmsgNT8c7ZAbGocMi",
                gd_id: "1VgVyfZ7rWVi5JUytmsgNT8c7ZAbGocMi",
                label: "Energie et enjeux",
                nodes: [],
              },
              {
                key: "1TmbYUGOCGGNbOo0f5pUo19kCH5ZKW83R",
                gd_id: "1TmbYUGOCGGNbOo0f5pUo19kCH5ZKW83R",
                label: "Communication écrite et orale",
                nodes: [],
              },
              {
                key: "1TqH_hKL2vvmPiNS_B-r26tuAKPWhmGl9",
                gd_id: "1TqH_hKL2vvmPiNS_B-r26tuAKPWhmGl9",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1TqiSmfwjexPGI8r6GjyTGXw3NsaZcWib",
                gd_id: "1TqiSmfwjexPGI8r6GjyTGXw3NsaZcWib",
                label: "Analyse numérique 1",
                nodes: [],
              },
              {
                key: "1VIPlXGNe2JnSmZRzz5mFI0RZQ1OBtgfp",
                gd_id: "1VIPlXGNe2JnSmZRzz5mFI0RZQ1OBtgfp",
                label: "Résistance des matériaux",
                nodes: [],
              },
              {
                key: "1VKogf71cUM7gjEcldEZGaBoOFJlx0-mC",
                gd_id: "1VKogf71cUM7gjEcldEZGaBoOFJlx0-mC",
                label: "Petro-physique et diagraphie",
                nodes: [],
              },
              {
                key: "1VPfloMGsjvVVyyXFsRqlUWruYtyzwo4G",
                gd_id: "1VPfloMGsjvVVyyXFsRqlUWruYtyzwo4G",
                label: "Forage horizontal dévié et multilatéral",
                nodes: [],
              },
              {
                key: "1VQ4nIJsTv1dhaWxm1T_5soyRswPrWfdc",
                gd_id: "1VQ4nIJsTv1dhaWxm1T_5soyRswPrWfdc",
                label: "Equipement de test",
                nodes: [],
              },
            ],
          },
          {
            key: "1It4n62Gf0HccFdh2YFJTsEpSIMSoJn1z",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1V-yy-kHmZBdAEa19yQLeOHPN-ip8SNTy",
                gd_id: "1V-yy-kHmZBdAEa19yQLeOHPN-ip8SNTy",
                label: "SOIP",
                nodes: [],
              },
              {
                key: "1V6-93ZcA8oHwqalHZpLxwoDrftJGN37C",
                gd_id: "1V6-93ZcA8oHwqalHZpLxwoDrftJGN37C",
                label: "MDR",
                nodes: [],
              },
              {
                key: "1VEiDwZ36tERbiNAncMvWZvXpogHdFwYH",
                gd_id: "1VEiDwZ36tERbiNAncMvWZvXpogHdFwYH",
                label: "Forage en Off-shore",
                nodes: [],
              },
              {
                key: "1VF3BWCvK-gj0IzsBVlVX9LwLqcOBukr6",
                gd_id: "1VF3BWCvK-gj0IzsBVlVX9LwLqcOBukr6",
                label: "Essais des puits",
                nodes: [],
              },
              {
                key: "1VHPP4i_8wTWPU3NmgikQis0MQ9imuMuV",
                gd_id: "1VHPP4i_8wTWPU3NmgikQis0MQ9imuMuV",
                label: "Analyse numérique II",
                nodes: [],
              },
              {
                key: "1V9Ratr7hMTRR3jZejUO_q8H3A2oMYAk1",
                gd_id: "1V9Ratr7hMTRR3jZejUO_q8H3A2oMYAk1",
                label: "MDF avancé",
                nodes: [],
              },
              {
                key: "1VDQvuGLaxy4f42Oo5MJxSL9tQr4p2hA1",
                gd_id: "1VDQvuGLaxy4f42Oo5MJxSL9tQr4p2hA1",
                label: "HSE",
                nodes: [],
              },
              {
                key: "1VH1ICXA6NRtbF9nbP9GDM9bX9NqHa1Tf",
                gd_id: "1VH1ICXA6NRtbF9nbP9GDM9bX9NqHa1Tf",
                label: "Audit Énergétique",
                nodes: [],
              },
            ],
          },
        ],
        oil_rig_mechanics: [
          {
            key: "1Imvu55pbg0VmTG46FTWzXnccNpk-WhxR",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1UuFZNmnJ6S9gXfrBK3H6wgq2eOKMQt6E",
                gd_id: "1UuFZNmnJ6S9gXfrBK3H6wgq2eOKMQt6E",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1WUEmhFBBzvGERq-0EAFyOGFMjtqvOKyA",
                gd_id: "1WUEmhFBBzvGERq-0EAFyOGFMjtqvOKyA",
                label: "Energie, enjeux et perspectives",
                nodes: [],
              },
              {
                key: "1WZwAdlOf9Rm9dhtYaOmGr_kl2zDh9spD",
                gd_id: "1WZwAdlOf9Rm9dhtYaOmGr_kl2zDh9spD",
                label: "Communication écrite et orale",
                nodes: [],
              },
              {
                key: "1UykHODJpddu41QRonHKskbe2c7W7hphs",
                gd_id: "1UykHODJpddu41QRonHKskbe2c7W7hphs",
                label: "Analyse numérique 1",
                nodes: [],
              },
              {
                key: "1WMYxXNrFfsNj1EDdZ6h6BtHI-xI8du8W",
                gd_id: "1WMYxXNrFfsNj1EDdZ6h6BtHI-xI8du8W",
                label: "Résistance des matériaux",
                nodes: [],
              },
              {
                key: "1WNY4A-TmZnCeB-o0JQA2qvLykdnec_RF",
                gd_id: "1WNY4A-TmZnCeB-o0JQA2qvLykdnec_RF",
                label: "Fabrication et métallurgie",
                nodes: [],
              },
              {
                key: "1WYDncFDA1I9PKaTm8C68KRLUrbacg6JJ",
                gd_id: "1WYDncFDA1I9PKaTm8C68KRLUrbacg6JJ",
                label: "Corrosion et protection 2",
                nodes: [],
              },
              {
                key: "1WKzmLvcQOQRE1nLr7Kz73dpUE39foKIP",
                gd_id: "1WKzmLvcQOQRE1nLr7Kz73dpUE39foKIP",
                label: "Thermodynamique 2",
                nodes: [],
              },
            ],
          },
          {
            key: "1IkS43TSaIniHKEtPM3kTeZvyie2b0Egq",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1W2gEWUqeBN5CPAvCuWrVpRYQzFkBxifQ",
                gd_id: "1W2gEWUqeBN5CPAvCuWrVpRYQzFkBxifQ",
                label: "Diagnostic-technique",
                nodes: [],
              },
              {
                key: "1W8G3tVPwnK4cSrzU8-zrGNCa_o9WC_Va",
                gd_id: "1W8G3tVPwnK4cSrzU8-zrGNCa_o9WC_Va",
                label: "Audit Énergétique",
                nodes: [],
              },
              {
                key: "1Vldz02GfgIkEx2suKCXEr4mJelEIlL_B",
                gd_id: "1Vldz02GfgIkEx2suKCXEr4mJelEIlL_B",
                label: "TMM",
                nodes: [],
              },
              {
                key: "1VrHBBLBF_AGSVrzNamYL1TUl8G4jiJRH",
                gd_id: "1VrHBBLBF_AGSVrzNamYL1TUl8G4jiJRH",
                label: "mécanique des fluides avancé",
                nodes: [],
              },
              {
                key: "1W-juiGIQzaAIKmbxufs3gWIo1Peq3teK",
                gd_id: "1W-juiGIQzaAIKmbxufs3gWIo1Peq3teK",
                label: "HSE",
                nodes: [],
              },
              {
                key: "1WJF7M-Y33rpMKmTD0cwqnvkFqwKubaQu",
                gd_id: "1WJF7M-Y33rpMKmTD0cwqnvkFqwKubaQu",
                label: "Analyse numérique II",
                nodes: [],
              },
              {
                key: "1ViHDCmtKU2Nch_845hezAZk2NPmS4OeC",
                gd_id: "1ViHDCmtKU2Nch_845hezAZk2NPmS4OeC",
                label: "Éléments de Machine",
                nodes: [],
              },
              {
                key: "1ViSKFiv5YdUxKSF42n58YqZYYMWtXTq2",
                gd_id: "1ViSKFiv5YdUxKSF42n58YqZYYMWtXTq2",
                label: "Transfer de chaleur",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        production_professional: [
          {
            key: "1YhgOoM1UWY2PO7Tglq5Xy4oTh5L77Vtv",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1aYQxr3gyAs9qVnpPYXTXmMIJg8pGPYdx",
                gd_id: "1aYQxr3gyAs9qVnpPYXTXmMIJg8pGPYdx",
                label: "Méthodes d’Exploration Pétrolières",
                nodes: [],
              },
              {
                key: "1bXhTBEq_HbijLeTate_uz6_XDmIqZvxz",
                gd_id: "1bXhTBEq_HbijLeTate_uz6_XDmIqZvxz",
                label: "Recherche Opérationnelle",
                nodes: [],
              },
              {
                key: "1a_ZgEzVouaTTb12BuNPHWIFhvo6goOtb",
                gd_id: "1a_ZgEzVouaTTb12BuNPHWIFhvo6goOtb",
                label: "Maintenance des Equipements Pétroliers",
                nodes: [],
              },
              {
                key: "1agp8RvDTG7AT1KOQrmSKAnyRQm_7e4Qp",
                gd_id: "1agp8RvDTG7AT1KOQrmSKAnyRQm_7e4Qp",
                label: "Equipements Electriques et Régulation Industrielle",
                nodes: [],
              },
              {
                key: "1bSX6FXUDiGglm5IsYRHAUIBYnnzj2ycP",
                gd_id: "1bSX6FXUDiGglm5IsYRHAUIBYnnzj2ycP",
                label: "Stimulation des Réservoirs",
                nodes: [],
              },
              {
                key: "1aScYvPGceFfZf6tdl_oLzWtIBrHq_VPz",
                gd_id: "1aScYvPGceFfZf6tdl_oLzWtIBrHq_VPz",
                label: "Production de Surface et Traitement de Gaz",
                nodes: [],
              },
              {
                key: "1aa4Jz3V10Y1zIfzG0RK3gtI1XsIIvUQQ",
                gd_id: "1aa4Jz3V10Y1zIfzG0RK3gtI1XsIIvUQQ",
                label: "Les Essais de Puits",
                nodes: [],
              },
              {
                key: "1aNd9TXBR3iv3zOs63qcx362J8or2sGsM",
                gd_id: "1aNd9TXBR3iv3zOs63qcx362J8or2sGsM",
                label: "Puits Horizontaux",
                nodes: [],
              },
            ],
          },
        ],
        production_academic: [
          {
            key: "1YsaROmMfZvGE05oP0SaM82DfzuVWI336",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1_mE-ysJ1jrtaBI2WcxW_chYNSiJkxTvp",
                gd_id: "1_mE-ysJ1jrtaBI2WcxW_chYNSiJkxTvp",
                label: "Recherche Opérationnelle",
                nodes: [],
              },
              {
                key: "1_tnAdz9aEFSoUAFrQPQfRGRxW78XY90S",
                gd_id: "1_tnAdz9aEFSoUAFrQPQfRGRxW78XY90S",
                label: "Méthodes d’Exploration Pétrolières",
                nodes: [],
              },
              {
                key: "1_icTwDGsfuuoC9wbeDAnwtITGcgqXPCY",
                gd_id: "1_icTwDGsfuuoC9wbeDAnwtITGcgqXPCY",
                label: "Stimulation des Réservoirs",
                nodes: [],
              },
              {
                key: "1a878apzxaixMxQjaE1qe-HQpXIZDdXac",
                gd_id: "1a878apzxaixMxQjaE1qe-HQpXIZDdXac",
                label: "Mécanique des Fluides Compressible",
                nodes: [],
              },
              {
                key: "1aB-SadZN8XVRIgDDi6ga9KoEHeLCp_Mk",
                gd_id: "1aB-SadZN8XVRIgDDi6ga9KoEHeLCp_Mk",
                label: "Maintenance des Equipements Pétroliers",
                nodes: [],
              },
              {
                key: "1aCtDXTvegXL0BemwpxxtzAKNJ2Bi5Aa_",
                gd_id: "1aCtDXTvegXL0BemwpxxtzAKNJ2Bi5Aa_",
                label: "Equipement Electrique et Régulation Industrielle",
                nodes: [],
              },
              {
                key: "1_iDGwginn5Fm0shh0L2kznuYTyc0RDl_",
                gd_id: "1_iDGwginn5Fm0shh0L2kznuYTyc0RDl_",
                label: "Traitement du Gaz",
                nodes: [],
              },
              {
                key: "1_oXV3WNH9o5AMzIqNZ5SZKCc8fTywRBP",
                gd_id: "1_oXV3WNH9o5AMzIqNZ5SZKCc8fTywRBP",
                label: "Production de Surface",
                nodes: [],
              },
              {
                key: "1aI9nRXWmsobpUC9xD3lq7tOH4umR9g46",
                gd_id: "1aI9nRXWmsobpUC9xD3lq7tOH4umR9g46",
                label: "Corrosion et Protection Cathodique",
                nodes: [],
              },
              {
                key: "1_nL1nPyNHrmklGNM1MR1_VB5OaxpC_yx",
                gd_id: "1_nL1nPyNHrmklGNM1MR1_VB5OaxpC_yx",
                label: "Puits Horizontaux",
                nodes: [],
              },
            ],
          },
        ],
        drilling: [
          {
            key: "1YkMHXY61khQF7o7F9Kzsb-lZOiHpZdoh",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1_RpaoTDlS_3_MBwprGwfjRC0pMZAmfoE",
                gd_id: "1_RpaoTDlS_3_MBwprGwfjRC0pMZAmfoE",
                label: "Problèmes de forage études et analyses",
                nodes: [],
              },
              {
                key: "1_T4_kppiJmLi6hW1HTImYySqN27eiqy7",
                gd_id: "1_T4_kppiJmLi6hW1HTImYySqN27eiqy7",
                label: "Management des chantier pétroliers",
                nodes: [],
              },
              {
                key: "1_TsJxTHNvYlseVlf1QJ_XQTgURFUQAVn",
                gd_id: "1_TsJxTHNvYlseVlf1QJ_XQTgURFUQAVn",
                label: "Maintenance des équipements pétroliers",
                nodes: [],
              },
              {
                key: "1_cphNk8e_2RmDQBbQsiOEnnOjrVQOLZj",
                gd_id: "1_cphNk8e_2RmDQBbQsiOEnnOjrVQOLZj",
                label: "Equipements électriques et régulation industrielle",
                nodes: [],
              },
              {
                key: "1b8zmAOLAffJdo9xUEcHkuS4UZ90IBMqP",
                gd_id: "1b8zmAOLAffJdo9xUEcHkuS4UZ90IBMqP",
                label: "Recherche opérationnelle",
                nodes: [],
              },
              {
                key: "1b705prKwcj7dNrdn4WDAr8KvP3_gJF5j",
                gd_id: "1b705prKwcj7dNrdn4WDAr8KvP3_gJF5j",
                label: "Well control avancé",
                nodes: [],
              },
              {
                key: "1_W_isQzizcTjjinXo8nnvIW5LP-SDvwR",
                gd_id: "1_W_isQzizcTjjinXo8nnvIW5LP-SDvwR",
                label: "Forage en underbalanced",
                nodes: [],
              },
            ],
          },
        ],
        oil_rig_mechanics: [
          {
            key: "1YhgOoM1UWY2PO7Tglq5Xy4oTh5L77Vtv",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1aYQxr3gyAs9qVnpPYXTXmMIJg8pGPYdx",
                gd_id: "1aYQxr3gyAs9qVnpPYXTXmMIJg8pGPYdx",
                label: "Méthodes d’Exploration Pétrolières",
                nodes: [],
              },
              {
                key: "1bXhTBEq_HbijLeTate_uz6_XDmIqZvxz",
                gd_id: "1bXhTBEq_HbijLeTate_uz6_XDmIqZvxz",
                label: "Recherche Opérationnelle",
                nodes: [],
              },
              {
                key: "1a_ZgEzVouaTTb12BuNPHWIFhvo6goOtb",
                gd_id: "1a_ZgEzVouaTTb12BuNPHWIFhvo6goOtb",
                label: "Maintenance des Equipements Pétroliers",
                nodes: [],
              },
              {
                key: "1agp8RvDTG7AT1KOQrmSKAnyRQm_7e4Qp",
                gd_id: "1agp8RvDTG7AT1KOQrmSKAnyRQm_7e4Qp",
                label: "Equipements Electriques et Régulation Industrielle",
                nodes: [],
              },
              {
                key: "1bSX6FXUDiGglm5IsYRHAUIBYnnzj2ycP",
                gd_id: "1bSX6FXUDiGglm5IsYRHAUIBYnnzj2ycP",
                label: "Stimulation des Réservoirs",
                nodes: [],
              },
              {
                key: "1aScYvPGceFfZf6tdl_oLzWtIBrHq_VPz",
                gd_id: "1aScYvPGceFfZf6tdl_oLzWtIBrHq_VPz",
                label: "Production de Surface et Traitement de Gaz",
                nodes: [],
              },
              {
                key: "1aa4Jz3V10Y1zIfzG0RK3gtI1XsIIvUQQ",
                gd_id: "1aa4Jz3V10Y1zIfzG0RK3gtI1XsIIvUQQ",
                label: "Les Essais de Puits",
                nodes: [],
              },
              {
                key: "1aNd9TXBR3iv3zOs63qcx362J8or2sGsM",
                gd_id: "1aNd9TXBR3iv3zOs63qcx362J8or2sGsM",
                label: "Puits Horizontaux",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
  },

  geology: {
    licence: {
      first_year: {
        common_year: [
          {
            key: "10iz7Q-KqSgFFAsebIgf6aNSr9E3Zbwde",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "12GRlCpg2EZA4X6GJRN2ydY_cCk3GS3wB",
                gd_id: "12GRlCpg2EZA4X6GJRN2ydY_cCk3GS3wB",
                label: "Initiation à la carte géologique",
                nodes: [],
              },
              {
                key: "1214Ta2yyYo5AZrrl9K33_Ijv9p-TeDtN",
                gd_id: "1214Ta2yyYo5AZrrl9K33_Ijv9p-TeDtN",
                label: "Techniques d'expression1",
                nodes: [],
              },
              {
                key: "12MLUlh6eEURCsyCq6NnYX4MgCv5DbFXv",
                gd_id: "12MLUlh6eEURCsyCq6NnYX4MgCv5DbFXv",
                label: "Informatique1",
                nodes: [],
              },
              {
                key: "12SDMILkJcMvkpjDNt93h4GJFvJx0M7Ps",
                gd_id: "12SDMILkJcMvkpjDNt93h4GJFvJx0M7Ps",
                label: "Géomorphologie",
                nodes: [],
              },
              {
                key: "12Uo5dpeMhpp3AhCo_c3IGDnMX9DSbs-S",
                gd_id: "12Uo5dpeMhpp3AhCo_c3IGDnMX9DSbs-S",
                label: "Biologie1",
                nodes: [],
              },
              {
                key: "12USzQ_BKg3dJJ3-ksAsUzSg8ZpGyficJ",
                gd_id: "12USzQ_BKg3dJJ3-ksAsUzSg8ZpGyficJ",
                label: "Chimie1",
                nodes: [],
              },
              {
                key: "12BZ-3v1kvVU0L37lmpngZ5rCZ0j6rXlG",
                gd_id: "12BZ-3v1kvVU0L37lmpngZ5rCZ0j6rXlG",
                label: "Physique1",
                nodes: [],
              },
              {
                key: "12BalFOjGqcRKetWIfyAQqsmPzlzT-3MB",
                gd_id: "12BalFOjGqcRKetWIfyAQqsmPzlzT-3MB",
                label: "Maths1",
                nodes: [],
              },
              {
                key: "12SReuNjtrBMvH19KbjloemyyQe1wyiol",
                gd_id: "12SReuNjtrBMvH19KbjloemyyQe1wyiol",
                label: "Géologie1",
                nodes: [],
              },
            ],
          },
          {
            key: "10fo3yTy8I29cBJ4WYsxmgLfw3lyvMrUe",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "11r-ctdC0BKMF5azyRKygMx5mSOQfWU74",
                gd_id: "11r-ctdC0BKMF5azyRKygMx5mSOQfWU74",
                label: "Initiation à la carte géologique",
                nodes: [],
              },
              {
                key: "11w2dfuIF3yH_iwaT8AXgk6_aj9CyOGAV",
                gd_id: "11w2dfuIF3yH_iwaT8AXgk6_aj9CyOGAV",
                label: "géologie de l'Algérie 1",
                nodes: [],
              },
              {
                key: "12xHe0HAkEeD8p3QE1CjPN-i_FvYOjdAF",
                gd_id: "12xHe0HAkEeD8p3QE1CjPN-i_FvYOjdAF",
                label: "Pétrologie des roches magmatiques",
                nodes: [],
              },
              {
                key: "12tFWh_Xtg9QDiP0Qawep911yemVnNy9l",
                gd_id: "12tFWh_Xtg9QDiP0Qawep911yemVnNy9l",
                label: "Techniques d'expression2",
                nodes: [],
              },
              {
                key: "11uoNKOwDxh54DH8ZC49bouGukEuzXMaB",
                gd_id: "11uoNKOwDxh54DH8ZC49bouGukEuzXMaB",
                label: "Informatique2",
                nodes: [],
              },
              {
                key: "11zPqX8eWSeu-7Qv10WQ49PoNdHhJ9pNP",
                gd_id: "11zPqX8eWSeu-7Qv10WQ49PoNdHhJ9pNP",
                label: "Biologie2",
                nodes: [],
              },
              {
                key: "11xoy4BF_k5unK51K0UiPHseHUyYFscv0",
                gd_id: "11xoy4BF_k5unK51K0UiPHseHUyYFscv0",
                label: "Chimie2",
                nodes: [],
              },
              {
                key: "1310S8il6LjS_pypdbg_1A1bvytaiKoGg",
                gd_id: "1310S8il6LjS_pypdbg_1A1bvytaiKoGg",
                label: "Physique2",
                nodes: [],
              },
              {
                key: "13Bj5QgOL_1mIQA6TIKYHegDAZ240Rn5E",
                gd_id: "13Bj5QgOL_1mIQA6TIKYHegDAZ240Rn5E",
                label: "Maths2",
                nodes: [],
              },
              {
                key: "11vaCnz9MWt-6UiSXIPX-7P17vhFO3ILo",
                gd_id: "11vaCnz9MWt-6UiSXIPX-7P17vhFO3ILo",
                label: "Géologie2",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        common_year: [
          {
            key: "10eEjwfInbjXowtLf1YJqfqBrqB5B1_z8",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "12o5oVjgoK9rbhgceHAOtovx353p-c3EN",
                gd_id: "12o5oVjgoK9rbhgceHAOtovx353p-c3EN",
                label: "Gestion de Base de données",
                nodes: [],
              },
              {
                key: "12nmtrZS1bXEjcnBMJBcsWC0stf2_qSYL",
                gd_id: "12nmtrZS1bXEjcnBMJBcsWC0stf2_qSYL",
                label: "Langue anglaise 1",
                nodes: [],
              },
              {
                key: "12kSUx0ggioBWRVywO2o9O_EiTqb-Pv2p",
                gd_id: "12kSUx0ggioBWRVywO2o9O_EiTqb-Pv2p",
                label: "Paléontologie",
                nodes: [],
              },
              {
                key: "12gy6QYjKfJy-CSu_QHbvv9AEkRKwJ6cE",
                gd_id: "12gy6QYjKfJy-CSu_QHbvv9AEkRKwJ6cE",
                label: "Tectonique 1",
                nodes: [],
              },
              {
                key: "12pSRvujLRIR8JTgo_V3aS9M6jUN438zm",
                gd_id: "12pSRvujLRIR8JTgo_V3aS9M6jUN438zm",
                label: "Cristallographie",
                nodes: [],
              },
              {
                key: "12mBDKq0LXyVa4-GP_Rg9kKUD77FPSShb",
                gd_id: "12mBDKq0LXyVa4-GP_Rg9kKUD77FPSShb",
                label: "Minéralogie",
                nodes: [],
              },
              {
                key: "12jCjvJ9R0SyQAcFM8nhQicY7MJCyli1a",
                gd_id: "12jCjvJ9R0SyQAcFM8nhQicY7MJCyli1a",
                label: "Stratigraphie",
                nodes: [],
              },
            ],
          },
          {
            key: "10dW822WV4Wsasmlb6zshyk7ODSnbOPs0",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "14MNL8nsk6UGvUL7QSohXZ4lZvJ7p7KCP",
                gd_id: "14MNL8nsk6UGvUL7QSohXZ4lZvJ7p7KCP",
                label: "Micropaléontologie",
                nodes: [],
              },
              {
                key: "12gKNOjFU1EbuWAcfQ-oLS8_TtCvy4lTb",
                gd_id: "12gKNOjFU1EbuWAcfQ-oLS8_TtCvy4lTb",
                label: "Anglais",
                nodes: [],
              },
              {
                key: "12akkYuPCQdciw5PM9PrAW9clRjQcVyvR",
                gd_id: "12akkYuPCQdciw5PM9PrAW9clRjQcVyvR",
                label: "Géologie appliquée",
                nodes: [],
              },
              {
                key: "148E0rc9_UnO61mxG7qNGWGohSaw9Cnrx",
                gd_id: "148E0rc9_UnO61mxG7qNGWGohSaw9Cnrx",
                label: "Stage de terrain",
                nodes: [],
              },
              {
                key: "147JSBO2jcGfP8IsVHd5ukVVtF2HjW-zj",
                gd_id: "147JSBO2jcGfP8IsVHd5ukVVtF2HjW-zj",
                label: "Sédimentologie",
                nodes: [],
              },
              {
                key: "14BbcVKpiU9UXojMK5CYAH_eUsEwWlbNN",
                gd_id: "14BbcVKpiU9UXojMK5CYAH_eUsEwWlbNN",
                label: "Pétrologie des roches sédimentaires",
                nodes: [],
              },
              {
                key: "12ZIf3L9hWdHZMsI3ne4OzgGA6MmxFJQV",
                gd_id: "12ZIf3L9hWdHZMsI3ne4OzgGA6MmxFJQV",
                label: "Géologie de l'Algérie2",
                nodes: [],
              },
              {
                key: "144U3nwrbaDs9FQlexdvPYssCMVBxPhbF",
                gd_id: "144U3nwrbaDs9FQlexdvPYssCMVBxPhbF",
                label: "Tectonique 2",
                nodes: [],
              },
              {
                key: "12cZgQKUz3iB_p8yTpLjLK0DSVLMmuAIW",
                gd_id: "12cZgQKUz3iB_p8yTpLjLK0DSVLMmuAIW",
                label: "Géochimie",
                nodes: [],
              },
              {
                key: "14FIMMlfhdgzRwsJVmCtj4zdfVqzDWyFM",
                gd_id: "14FIMMlfhdgzRwsJVmCtj4zdfVqzDWyFM",
                label: "Pétrologie des roches métamorphiques",
                nodes: [],
              },
            ],
          },
        ],
      },

      third_year: {
        fundamental_geology_stratigraphy_sedimentology: [
          {
            key: "10cQJkzD3sZxv93NINXQo4JugrLA_eOD8",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "13ozJ8hga9PoIP4S-WoTaPLROTtAb_Vre",
                gd_id: "13ozJ8hga9PoIP4S-WoTaPLROTtAb_Vre",
                label: "Géodynamique globale et métamorphisme",
                nodes: [],
              },
              {
                key: "13abkQePuUrf35E_HjluRW6THLal6L4rz",
                gd_id: "13abkQePuUrf35E_HjluRW6THLal6L4rz",
                label: "Informatique et Statistiques",
                nodes: [],
              },
              {
                key: "13Xv1qKVEapfbq6gOf49OnHTR3L9EPHKN",
                gd_id: "13Xv1qKVEapfbq6gOf49OnHTR3L9EPHKN",
                label: "Stage",
                nodes: [],
              },
              {
                key: "13ahuyB-RD5nZqs4gqihx5qAq5Zkj-k0L",
                gd_id: "13ahuyB-RD5nZqs4gqihx5qAq5Zkj-k0L",
                label: "Géophysique3",
                nodes: [],
              },
              {
                key: "13JrWAph9Wyl8cGl2pktUbj5RrAP7Tms2",
                gd_id: "13JrWAph9Wyl8cGl2pktUbj5RrAP7Tms2",
                label: "Tectonique",
                nodes: [],
              },
              {
                key: "13OMi39_k_RwniAXIjwLNPklRXDQh_IJ_",
                gd_id: "13OMi39_k_RwniAXIjwLNPklRXDQh_IJ_",
                label: "Sédimentologie",
                nodes: [],
              },
              {
                key: "13qnuSYqId6boSGi4eCmpGK7Pug7gH8jf",
                gd_id: "13qnuSYqId6boSGi4eCmpGK7Pug7gH8jf",
                label: "Géodynamique des Bassins",
                nodes: [],
              },
              {
                key: "13gP951GRwq_ltavTh-8MhzhgOAXju5gy",
                gd_id: "13gP951GRwq_ltavTh-8MhzhgOAXju5gy",
                label: "Géologie Historique",
                nodes: [],
              },
            ],
          },
          {
            key: "10c9VOK_riBh3wu4LMHthUVSgkhPg2xAd",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "158E1ecpTIyTagCdr1TzBXmdwsaUOOgAw",
                gd_id: "158E1ecpTIyTagCdr1TzBXmdwsaUOOgAw",
                label: "Langue",
                nodes: [],
              },
              {
                key: "14kXusA2J993qdHlyKYOXSzOQMqF18Omm",
                gd_id: "14kXusA2J993qdHlyKYOXSzOQMqF18Omm",
                label: "Stage de terrain",
                nodes: [],
              },
              {
                key: "13DMEI_Uw0ta1rTYHlrxFoWJ3WN2qe4MW",
                gd_id: "13DMEI_Uw0ta1rTYHlrxFoWJ3WN2qe4MW",
                label: "Informatique",
                nodes: [],
              },
              {
                key: "15-M5Bx6GiH4qSJOzeB6mF6uZyRFZLdmG",
                gd_id: "15-M5Bx6GiH4qSJOzeB6mF6uZyRFZLdmG",
                label: "Méthodes géophysiques",
                nodes: [],
              },
              {
                key: "14tAm6ZtC4Ojeq0Th6oWTJs1HKrvhVDrD",
                gd_id: "14tAm6ZtC4Ojeq0Th6oWTJs1HKrvhVDrD",
                label: "Paléontologie 2",
                nodes: [],
              },
              {
                key: "14jsmPrZAKy0pNfFXoPo5Tjnh7d4V0F2V",
                gd_id: "14jsmPrZAKy0pNfFXoPo5Tjnh7d4V0F2V",
                label: "Sédimentologie 3",
                nodes: [],
              },
            ],
          },
        ],
        hydrocarbon_geology: [
          {
            key: "10b7rHUvo7-Fgv9ZqdoOETaJU_e3aUwOu",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "14Nym7t0keIUdmLXdoVODRb5O4Go4lutz",
                gd_id: "14Nym7t0keIUdmLXdoVODRb5O4Go4lutz",
                label: "Informatique et Statistique",
                nodes: [],
              },
              {
                key: "14SvHwXAE0xfMRiyHPtMVYXAwIjAA7POH",
                gd_id: "14SvHwXAE0xfMRiyHPtMVYXAwIjAA7POH",
                label: "Géostatistique",
                nodes: [],
              },
              {
                key: "14YMd_06mX9eanU-80AL3IxgXAUQYOpsR",
                gd_id: "14YMd_06mX9eanU-80AL3IxgXAUQYOpsR",
                label: "Géophysique",
                nodes: [],
              },
              {
                key: "14SK4RGUOiVtyiZJjdzAVFLYNVVLo2fpz",
                gd_id: "14SK4RGUOiVtyiZJjdzAVFLYNVVLo2fpz",
                label: "Hydrogéologie pétrolière",
                nodes: [],
              },
              {
                key: "14j_5Z8TP6vlbaYi3xxItFq_YPJL7d11W",
                gd_id: "14j_5Z8TP6vlbaYi3xxItFq_YPJL7d11W",
                label: "Bassin sédimentaire",
                nodes: [],
              },
              {
                key: "14hN5cxo8oIoveTIk_m2FWqVcqNi6XyHt",
                gd_id: "14hN5cxo8oIoveTIk_m2FWqVcqNi6XyHt",
                label: "Forage 1",
                nodes: [],
              },
              {
                key: "14bAMwPG-tWaOvMEFgzsYUf4rjx9sKDiP",
                gd_id: "14bAMwPG-tWaOvMEFgzsYUf4rjx9sKDiP",
                label: "Géochimie organique",
                nodes: [],
              },
              {
                key: "14NQaoZh2X48QlHu-CPnnxWM8XUcTJcD-",
                gd_id: "14NQaoZh2X48QlHu-CPnnxWM8XUcTJcD-",
                label: "Pétrophysique",
                nodes: [],
              },
              {
                key: "14fvIxH1K5gHqkItm-wPWRsjjBw2Mx1tR",
                gd_id: "14fvIxH1K5gHqkItm-wPWRsjjBw2Mx1tR",
                label: "Gisement",
                nodes: [],
              },
            ],
          },
          {
            key: "10ak9MRRA00hQE9XUbGCFHstfsV9bmWUz",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "14NAxVbMFc5DZZyn-i9h_nAdQsrNGhb8z",
                gd_id: "14NAxVbMFc5DZZyn-i9h_nAdQsrNGhb8z",
                label: "Anglais",
                nodes: [],
              },
              {
                key: "15PC4N5YK0pq6YnWTg_uHRl5khCdOz1Ut",
                gd_id: "15PC4N5YK0pq6YnWTg_uHRl5khCdOz1Ut",
                label: "stage",
                nodes: [],
              },
              {
                key: "15tQ__8K81-Puw5A66r8OTn0uJ-7LxMMb",
                gd_id: "15tQ__8K81-Puw5A66r8OTn0uJ-7LxMMb",
                label: "Champs et provinces pétrogazifères",
                nodes: [],
              },
              {
                key: "15h_UR3xsAtGJxSZsagJLjuYZWPnGFshL",
                gd_id: "15h_UR3xsAtGJxSZsagJLjuYZWPnGFshL",
                label: "Géophysique appliquée",
                nodes: [],
              },
              {
                key: "15lNgWT3Ni_n_XkEGloQgE35WAy9Z9wmo",
                gd_id: "15lNgWT3Ni_n_XkEGloQgE35WAy9Z9wmo",
                label: "Forage 2",
                nodes: [],
              },
              {
                key: "15Uw6HxenIqc0_bcQ__511hq6ME7EqF2o",
                gd_id: "15Uw6HxenIqc0_bcQ__511hq6ME7EqF2o",
                label: "Mudlogging",
                nodes: [],
              },
              {
                key: "15Vh9UwP4dsmGp6MIfVCjpSfokfXOrsqg",
                gd_id: "15Vh9UwP4dsmGp6MIfVCjpSfokfXOrsqg",
                label: "Logging",
                nodes: [],
              },
              {
                key: "15Vu60TbLIhUeEG7730On8Sk7i-4C6ilN",
                gd_id: "15Vu60TbLIhUeEG7730On8Sk7i-4C6ilN",
                label: "informatique",
                nodes: [],
              },
              {
                key: "167oPbNghxljbG5qy6TrbB37mvfnPa5fY",
                gd_id: "167oPbNghxljbG5qy6TrbB37mvfnPa5fY",
                label: "Bassins Sédimentaires",
                nodes: [],
              },
              {
                key: "15aXpCOMOAgtuBCYcv5T8DlYRQlAbr-8G",
                gd_id: "15aXpCOMOAgtuBCYcv5T8DlYRQlAbr-8G",
                label: "Géostatistique",
                nodes: [],
              },
              {
                key: "15hw0RZoMUoePWWAlZdFtlCZ5tZLMo8j4",
                gd_id: "15hw0RZoMUoePWWAlZdFtlCZ5tZLMo8j4",
                label: "Géochimie organique",
                nodes: [],
              },
              {
                key: "15jTVcZLRqCK-HshPYLkxGejMLP2eTOWZ",
                gd_id: "15jTVcZLRqCK-HshPYLkxGejMLP2eTOWZ",
                label: "Gisement",
                nodes: [],
              },
              {
                key: "15_NY9PQchdpqSAyx-mDyvmXrXeiKpsoL",
                gd_id: "15_NY9PQchdpqSAyx-mDyvmXrXeiKpsoL",
                label: "hydrogéologie pétroliière",
                nodes: [],
              },
              {
                key: "15eYB_-qlHP42qh_gcS1W0fk2cFdfFx5s",
                gd_id: "15eYB_-qlHP42qh_gcS1W0fk2cFdfFx5s",
                label: "Géophysique1",
                nodes: [],
              },
              {
                key: "15URezi3HZfKUpTHr6b4sdNSa1C7kSmda",
                gd_id: "15URezi3HZfKUpTHr6b4sdNSa1C7kSmda",
                label: "Pétrophysique",
                nodes: [],
              },
            ],
          },
        ],
        hydrogeology: [
          {
            key: "10ZVKuNcqL0zOzY99vTtK_6B8eiI6-kWm",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "17F4T_03Ite956qH8l4-CnCzZYF5AtzKY",
                gd_id: "17F4T_03Ite956qH8l4-CnCzZYF5AtzKY",
                label: "Géodynamique globale et métamorphisme",
                nodes: [],
              },
              {
                key: "16nh1UbQZrzoLvf1CcE_Ma5o2EHIyBmoY",
                gd_id: "16nh1UbQZrzoLvf1CcE_Ma5o2EHIyBmoY",
                label: "Stage",
                nodes: [],
              },
              {
                key: "16pWRWMMSHLUB6akyp0Ae8HHL3WI4ryKP",
                gd_id: "16pWRWMMSHLUB6akyp0Ae8HHL3WI4ryKP",
                label: "pétrophysique",
                nodes: [],
              },
              {
                key: "17DCZJYl90aVD0gYGvJ6w_gCl23uDUIwt",
                gd_id: "17DCZJYl90aVD0gYGvJ6w_gCl23uDUIwt",
                label: "Géophysique 2",
                nodes: [],
              },
              {
                key: "176_2HwQpawtS3su9qFLhwgqFIxATwpaH",
                gd_id: "176_2HwQpawtS3su9qFLhwgqFIxATwpaH",
                label: "Informatique et Statistique",
                nodes: [],
              },
              {
                key: "16wNW8zrz9aWyyd81yK-WikIACpOGFseH",
                gd_id: "16wNW8zrz9aWyyd81yK-WikIACpOGFseH",
                label: "Math",
                nodes: [],
              },
              {
                key: "15F-Jthpz-rMOwVkZdE-798RAJVfKF1xW",
                gd_id: "15F-Jthpz-rMOwVkZdE-798RAJVfKF1xW",
                label: "géodynamique des bassins",
                nodes: [],
              },
              {
                key: "17DPbLz2HMQ1vuKUqWLdnCDUVxG_0kuLB",
                gd_id: "17DPbLz2HMQ1vuKUqWLdnCDUVxG_0kuLB",
                label: "géologie historique",
                nodes: [],
              },
            ],
          },
          {
            key: "10UMmgwz6HmN0Pwkg1bHqCI7F5RfN8q3c",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "16LodMx2pXFztjpFq17nklKO7eb29en1W",
                gd_id: "16LodMx2pXFztjpFq17nklKO7eb29en1W",
                label: "Hydrochimie",
                nodes: [],
              },
              {
                key: "16WVXHJefd10ufEqiVMaYOeADfTHfad7v",
                gd_id: "16WVXHJefd10ufEqiVMaYOeADfTHfad7v",
                label: "forage d'eau",
                nodes: [],
              },
              {
                key: "16B8hRUFwtGtGb6ErlRQOVEOHMP2ljljF",
                gd_id: "16B8hRUFwtGtGb6ErlRQOVEOHMP2ljljF",
                label: "hydrologie",
                nodes: [],
              },
              {
                key: "16__surUEiBcYQDKp9nB0F6sxJM1FZriX",
                gd_id: "16__surUEiBcYQDKp9nB0F6sxJM1FZriX",
                label: "climatologie",
                nodes: [],
              },
              {
                key: "16IoFI6f5PSPtXEIFFmSl99xso1oaPwl_",
                gd_id: "16IoFI6f5PSPtXEIFFmSl99xso1oaPwl_",
                label: "hydrodynamique",
                nodes: [],
              },
              {
                key: "16GeJJyHzCXwnquN5wjQAboAjoirM5Xxm",
                gd_id: "16GeJJyHzCXwnquN5wjQAboAjoirM5Xxm",
                label: "hydrogéologie",
                nodes: [],
              },
              {
                key: "188JzRnlk5FoesflDs0NsgQZUAnwD2c4x",
                gd_id: "188JzRnlk5FoesflDs0NsgQZUAnwD2c4x",
                label: "sortie scientifique",
                nodes: [],
              },
              {
                key: "16doOPbukKwn7iDgHh_rSm8yeLRsZyeqC",
                gd_id: "16doOPbukKwn7iDgHh_rSm8yeLRsZyeqC",
                label: "Anglais",
                nodes: [],
              },
              {
                key: "18F4bluhZwbbmj8RmtkVI9bM3ylU0sNdA",
                gd_id: "18F4bluhZwbbmj8RmtkVI9bM3ylU0sNdA",
                label: "informatique4",
                nodes: [],
              },
              {
                key: "16N90aBLR5JAzEEqfR7Xp87zFYClHsDyX",
                gd_id: "16N90aBLR5JAzEEqfR7Xp87zFYClHsDyX",
                label: "Géophysique 3",
                nodes: [],
              },
            ],
          },
        ],
        petroleum_geology: [
          {
            key: "10TZfZINPuRi0Vm_fP6r4_VkqfoU1A4Tj",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "17xfveTYYB8fDDrxq_mDtZ7b7jFfYjRxP",
                gd_id: "17xfveTYYB8fDDrxq_mDtZ7b7jFfYjRxP",
                label: "Géodynamique globale et métamorphisme",
                nodes: [],
              },
              {
                key: "17bF9CjL8rrhPT0KWCXAlofdraj07CWZn",
                gd_id: "17bF9CjL8rrhPT0KWCXAlofdraj07CWZn",
                label: "Informatique",
                nodes: [],
              },
              {
                key: "17MRslv6pKbE-g0EVsDze4OPW2qq3KwQE",
                gd_id: "17MRslv6pKbE-g0EVsDze4OPW2qq3KwQE",
                label: "Stage",
                nodes: [],
              },
              {
                key: "17a_hsX4QCLcUopaca5AP3-nZi2i4qtXO",
                gd_id: "17a_hsX4QCLcUopaca5AP3-nZi2i4qtXO",
                label: "Informatique et Statistiques",
                nodes: [],
              },
              {
                key: "17l7ji7WHfnurtMYQZE0XfN7ULg5f8exx",
                gd_id: "17l7ji7WHfnurtMYQZE0XfN7ULg5f8exx",
                label: "Géophysique3",
                nodes: [],
              },
              {
                key: "17N7s8LEHFPIlalApSRsujMN3NWrnl5fk",
                gd_id: "17N7s8LEHFPIlalApSRsujMN3NWrnl5fk",
                label: "Pétrophysique",
                nodes: [],
              },
              {
                key: "18-HNLAEjWHWwMehxHrkKncCycIkt5bbP",
                gd_id: "18-HNLAEjWHWwMehxHrkKncCycIkt5bbP",
                label: "Géodynamique des Bassins",
                nodes: [],
              },
              {
                key: "17W6oXWPqjfSzVCcZkEh3FQl9raC4BwXZ",
                gd_id: "17W6oXWPqjfSzVCcZkEh3FQl9raC4BwXZ",
                label: "Maths",
                nodes: [],
              },
              {
                key: "17pfRCNtGCKZBtioUYsXzdWtOSAwVu0EC",
                gd_id: "17pfRCNtGCKZBtioUYsXzdWtOSAwVu0EC",
                label: "Géologie Historique",
                nodes: [],
              },
            ],
          },
          {
            key: "10Sb5yeCpMX8HzfMgWrUjJRmlGrpek1Ay",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "18J5LqFw-GOdwY9EORh-npAtSbyKSbNW1",
                gd_id: "18J5LqFw-GOdwY9EORh-npAtSbyKSbNW1",
                label: "Mudlogging",
                nodes: [],
              },
              {
                key: "18LsjCiTsR-mP4HV9bS1T2PXppYjbneNz",
                gd_id: "18LsjCiTsR-mP4HV9bS1T2PXppYjbneNz",
                label: "Logging",
                nodes: [],
              },
              {
                key: "18PY3I1T1jiC4uefMZvY4ib9QTzM-Bk-W",
                gd_id: "18PY3I1T1jiC4uefMZvY4ib9QTzM-Bk-W",
                label: "Hydrogéologie pétrolière",
                nodes: [],
              },
              {
                key: "17HaveHX1b1sIGCewK-WLB-4z2X5dzq_m",
                gd_id: "17HaveHX1b1sIGCewK-WLB-4z2X5dzq_m",
                label: "Forage pétrolier",
                nodes: [],
              },
              {
                key: "18kyMmW2GyNjopeaGGsOmqs7duP8lOxhG",
                gd_id: "18kyMmW2GyNjopeaGGsOmqs7duP8lOxhG",
                label: "Gisement",
                nodes: [],
              },
              {
                key: "17Ie44glX5rj8ZCS3ONDWnWALiZGS_wlp",
                gd_id: "17Ie44glX5rj8ZCS3ONDWnWALiZGS_wlp",
                label: "Champs et provinces",
                nodes: [],
              },
              {
                key: "17KGAc3xJzjMY7NZkuhz2K1WwjrgWPch3",
                gd_id: "17KGAc3xJzjMY7NZkuhz2K1WwjrgWPch3",
                label: "Bassins sédimentaires",
                nodes: [],
              },
              {
                key: "18QB-DK9-CVYO_n8AxNkbh1ICPRRPLzQZ",
                gd_id: "18QB-DK9-CVYO_n8AxNkbh1ICPRRPLzQZ",
                label: "Géophysique4",
                nodes: [],
              },
              {
                key: "17KdLHgTCbTGDb4Ehh9gCzQ0MEmh_UMMj",
                gd_id: "17KdLHgTCbTGDb4Ehh9gCzQ0MEmh_UMMj",
                label: "Anglais",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
    master: {
      first_year: {
        sedimentary_basin_geology: [
          {
            key: "11NLNnYft77iaDqMX9-qn8q7eDRi2Dxmr",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1C4s9R8h10Fd1TFIAXZBEDaLl9gAkyheL",
                gd_id: "1C4s9R8h10Fd1TFIAXZBEDaLl9gAkyheL",
                label: "Anglais 1",
                nodes: [],
              },
              {
                key: "1CAXCf_VMRnN-4jRnAoY-qfv4aW3RphsK",
                gd_id: "1CAXCf_VMRnN-4jRnAoY-qfv4aW3RphsK",
                label: "Analyse structurale",
                nodes: [],
              },
              {
                key: "1CJKomIkHnT8c1iOxh4BNdR14i3Ro_x6q",
                gd_id: "1CJKomIkHnT8c1iOxh4BNdR14i3Ro_x6q",
                label: "Analyse des données",
                nodes: [],
              },
              {
                key: "1BpJRFNFQ0JjbQ36NjVyTMfEqNAPcvbsN",
                gd_id: "1BpJRFNFQ0JjbQ36NjVyTMfEqNAPcvbsN",
                label: "Géochimie 1",
                nodes: [],
              },
              {
                key: "1BxhORSBxL1CZpgSxciug2zkl_8phFfrJ",
                gd_id: "1BxhORSBxL1CZpgSxciug2zkl_8phFfrJ",
                label: "Environnements Sédimentaires 1",
                nodes: [],
              },
              {
                key: "1E1ZEbj0vMmPkJq38bpJIhki4XX3hzDW8",
                gd_id: "1E1ZEbj0vMmPkJq38bpJIhki4XX3hzDW8",
                label: "Micropaléontologie",
                nodes: [],
              },
              {
                key: "1C1JRWkfSzfZ7CEuKvYc4rU-qft1vrA_C",
                gd_id: "1C1JRWkfSzfZ7CEuKvYc4rU-qft1vrA_C",
                label: "Bio stratigraphie",
                nodes: [],
              },
              {
                key: "1CDLG3xjAm8Wxg5nPufgK0ZSZ64Q0cT0u",
                gd_id: "1CDLG3xjAm8Wxg5nPufgK0ZSZ64Q0cT0u",
                label: "Analyse et stratigraphie séquentielle",
                nodes: [],
              },
            ],
          },
          {
            key: "11Gn9ob9B9eVIPrZZbbNa1qkhuj2tR6Yj",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1DwbbNIv_dyCt9QW_3tgVhQZcKPpJ9jEV",
                gd_id: "1DwbbNIv_dyCt9QW_3tgVhQZcKPpJ9jEV",
                label: "Anglais 2",
                nodes: [],
              },
              {
                key: "1DJ4huuWs1OdUD91z5l6LIUdEcjcaziD0",
                gd_id: "1DJ4huuWs1OdUD91z5l6LIUdEcjcaziD0",
                label: "Télédétection 1",
                nodes: [],
              },
              {
                key: "1DjL7F-8Hb3xv3s8719HJD2Zh2XqtP7BK",
                gd_id: "1DjL7F-8Hb3xv3s8719HJD2Zh2XqtP7BK",
                label: "Forage et réservoirs pétroliers",
                nodes: [],
              },
              {
                key: "1DWu1ElZZuPARiqnq5a22dMSA7ln_9-Dv",
                gd_id: "1DWu1ElZZuPARiqnq5a22dMSA7ln_9-Dv",
                label: "Géoressources 1",
                nodes: [],
              },
              {
                key: "1DjgpVC7n1FtSOSo07oBMDvmgMpef_A_x",
                gd_id: "1DjgpVC7n1FtSOSo07oBMDvmgMpef_A_x",
                label: "Environnements Sédimentaires 2",
                nodes: [],
              },
              {
                key: "1DqTXPHBeV5ZKaDvKAxmqVWVtkU4xJF9Z",
                gd_id: "1DqTXPHBeV5ZKaDvKAxmqVWVtkU4xJF9Z",
                label: "Dynamique des bassins sédimentaires",
                nodes: [],
              },
              {
                key: "1DbzziTDjhm7aSKD9iL-_eY1OX4jY95Y6",
                gd_id: "1DbzziTDjhm7aSKD9iL-_eY1OX4jY95Y6",
                label: "Géochimie 2",
                nodes: [],
              },
            ],
          },
        ],
        geology_of_hydrocarbons: [
          {
            key: "11ojo5X70UnI_JBixH9MzBLyYhYB8aPr1",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "19rHEImifgUmZbyNL9X7KBExK7rSV8fPy",
                gd_id: "19rHEImifgUmZbyNL9X7KBExK7rSV8fPy",
                label: "Anglais technique I",
                nodes: [],
              },
              {
                key: "19UR6ZVhHXfdvOiI6W2aDwoMPJX9lRsic",
                gd_id: "19UR6ZVhHXfdvOiI6W2aDwoMPJX9lRsic",
                label: "Méthodes d'étude des bassins sédimentaires",
                nodes: [],
              },
              {
                key: "19jCoO7xaZeG61gAD6pQHpbkvcNShlDqF",
                gd_id: "19jCoO7xaZeG61gAD6pQHpbkvcNShlDqF",
                label: "Géochimie organique",
                nodes: [],
              },
              {
                key: "19_szSDmKAiuLpGS4jQP7wbUkSz4dUbET",
                gd_id: "19_szSDmKAiuLpGS4jQP7wbUkSz4dUbET",
                label: "Mathématique I",
                nodes: [],
              },
              {
                key: "19Qe5X8CL1Vf_mq5er2xZhNEpaZobrshn",
                gd_id: "19Qe5X8CL1Vf_mq5er2xZhNEpaZobrshn",
                label: "Sédimentologie",
                nodes: [],
              },
              {
                key: "19QEy4ofz5m4tsh2K63Ol1kKF7hZJb6tT",
                gd_id: "19QEy4ofz5m4tsh2K63Ol1kKF7hZJb6tT",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "19Qh3Wmd1UGbIURiZapQWgOb8gitQgX99",
                gd_id: "19Qh3Wmd1UGbIURiZapQWgOb8gitQgX99",
                label: "Pétrophysique",
                nodes: [],
              },
              {
                key: "19TaO0e363i_NuAj3og2aB-VNqbA_YH2m",
                gd_id: "19TaO0e363i_NuAj3og2aB-VNqbA_YH2m",
                label: "Physique du Milieux Poreux",
                nodes: [],
              },
              {
                key: "19YXqLI4Tm-iJSAzIdXFMxi_Dd-iiWdsy",
                gd_id: "19YXqLI4Tm-iJSAzIdXFMxi_Dd-iiWdsy",
                label: "Mécanique des fluides et des roches",
                nodes: [],
              },
              {
                key: "19oeThZQ_1Kd49zITgNyF1xSqNksncH1M",
                gd_id: "19oeThZQ_1Kd49zITgNyF1xSqNksncH1M",
                label: "Exploration des hydrocarbures",
                nodes: [],
              },
            ],
          },
          {
            key: "11jxJST8SV1qngq1ag-KmYXbISlUPhuZK",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "19N9FDJnKC7gb9fGfn4sq8O5fhhINrJSP",
                gd_id: "19N9FDJnKC7gb9fGfn4sq8O5fhhINrJSP",
                label: "Anglais technique II",
                nodes: [],
              },
              {
                key: "1AZ8VgX9eH1Uyj0bFHcGUcxt8tb0W4d7e",
                gd_id: "1AZ8VgX9eH1Uyj0bFHcGUcxt8tb0W4d7e",
                label: "Sortie sur terrain (une Semaine) travail et d’étude",
                nodes: [],
              },
              {
                key: "1AdmgRRccjXklS3SiIWhrJtesmD2sLLqw",
                gd_id: "1AdmgRRccjXklS3SiIWhrJtesmD2sLLqw",
                label: "Mathématique II",
                nodes: [],
              },
              {
                key: "19-IW00gZBt0qbZ054wOR40yjUVRdVULp",
                gd_id: "19-IW00gZBt0qbZ054wOR40yjUVRdVULp",
                label: "Géostatistique",
                nodes: [],
              },
              {
                key: "19KoeZKQA8QC-6VhAWpi5j1m4gwit1gnl",
                gd_id: "19KoeZKQA8QC-6VhAWpi5j1m4gwit1gnl",
                label:
                  "Caractérisation et développement des réservoirs pétroliers",
                nodes: [],
              },
              {
                key: "196t-Nh7Y1IIyqsE9Hc9U0yEPg5r-qqne",
                gd_id: "196t-Nh7Y1IIyqsE9Hc9U0yEPg5r-qqne",
                label: "Gisement",
                nodes: [],
              },
              {
                key: "19I54J3vLWuFpudOo3zpS2_GaxfOAht7k",
                gd_id: "19I54J3vLWuFpudOo3zpS2_GaxfOAht7k",
                label: "Forage",
                nodes: [],
              },
              {
                key: "1AboDY1TpPMQRvZ39M02Y4WYdmfwyRdLI",
                gd_id: "1AboDY1TpPMQRvZ39M02Y4WYdmfwyRdLI",
                label: "Mud logging",
                nodes: [],
              },
              {
                key: "1Ajc_Te4B0Zq35uLOVUjJ9sJDgYarcGfL",
                gd_id: "1Ajc_Te4B0Zq35uLOVUjJ9sJDgYarcGfL",
                label: "Logging",
                nodes: [],
              },
            ],
          },
        ],
        hydrogeology: [
          {
            key: "11a-gNK47SEdNenlkshzcf329z89rJ7sj",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1AFSaBjYk4O3FVLkdUtWbGYi77PAyKPQO",
                gd_id: "1AFSaBjYk4O3FVLkdUtWbGYi77PAyKPQO",
                label: "français",
                nodes: [],
              },
              {
                key: "1ABoCIgdXibmyraTiTAWJP8qY9z3BuFrk",
                gd_id: "1ABoCIgdXibmyraTiTAWJP8qY9z3BuFrk",
                label: "initiation à l’utilisation logiciels",
                nodes: [],
              },
              {
                key: "1AOh5LdhmDe6FK2ycwN2d_yZjbA5PIlHB",
                gd_id: "1AOh5LdhmDe6FK2ycwN2d_yZjbA5PIlHB",
                label: "chimie des eaux",
                nodes: [],
              },
              {
                key: "1ADy1kaYsKNpyVMoOS_7ey5IUyxz6obUK",
                gd_id: "1ADy1kaYsKNpyVMoOS_7ey5IUyxz6obUK",
                label: "hydrologie",
                nodes: [],
              },
              {
                key: "1AEs5gjz2AZtOJ3rnDcp2jb2CLY_Uw8bA",
                gd_id: "1AEs5gjz2AZtOJ3rnDcp2jb2CLY_Uw8bA",
                label: "hydrogéologie",
                nodes: [],
              },
              {
                key: "1AMBKE-Tj2MjI0HaGTn2EBXq27ale0u7n",
                gd_id: "1AMBKE-Tj2MjI0HaGTn2EBXq27ale0u7n",
                label: "Diagraphie",
                nodes: [],
              },
              {
                key: "1A9bfZCUOIIJrJsLQP5Xciadd8bltbOj1",
                gd_id: "1A9bfZCUOIIJrJsLQP5Xciadd8bltbOj1",
                label: "Modélisation1",
                nodes: [],
              },
            ],
          },
          {
            key: "11_yDC6Pc-kMIsAyxRT4xb7ueVTHNBwax",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1A8Jf99VmUm7dbU5RTRLozYIsVYKi3KGG",
                gd_id: "1A8Jf99VmUm7dbU5RTRLozYIsVYKi3KGG",
                label: "anglais",
                nodes: [],
              },
              {
                key: "1BkbcW5aLZNiwFOcRcZtC8pswSZ-gtCd_",
                gd_id: "1BkbcW5aLZNiwFOcRcZtC8pswSZ-gtCd_",
                label: "stage de terrain",
                nodes: [],
              },
              {
                key: "1A-YU0OWXjQH4wbSrvVm6zf5h6mNBtMlJ",
                gd_id: "1A-YU0OWXjQH4wbSrvVm6zf5h6mNBtMlJ",
                label: "mathématiques",
                nodes: [],
              },
              {
                key: "1Bl7vPDZF4n8O4dVi7eUpqFoNKfFnKjOM",
                gd_id: "1Bl7vPDZF4n8O4dVi7eUpqFoNKfFnKjOM",
                label: "SIG",
                nodes: [],
              },
              {
                key: "1BY5Y1GVoviAaO-OYjtasPDYytzeZXoYe",
                gd_id: "1BY5Y1GVoviAaO-OYjtasPDYytzeZXoYe",
                label: "traitement des eaux",
                nodes: [],
              },
              {
                key: "1Bn3tTfJtKmNChMir2nxrl0TcFzEG_3YE",
                gd_id: "1Bn3tTfJtKmNChMir2nxrl0TcFzEG_3YE",
                label: "pollution des eaux",
                nodes: [],
              },
              {
                key: "19zCuHY2ZAWJa2Aw7NIDUF4y-bu01t-a5",
                gd_id: "19zCuHY2ZAWJa2Aw7NIDUF4y-bu01t-a5",
                label: "modélisation 2",
                nodes: [],
              },
              {
                key: "1A5CRRXrHL5HmL-obErFxiJvj5EC-EupI",
                gd_id: "1A5CRRXrHL5HmL-obErFxiJvj5EC-EupI",
                label: "hydrodynamique",
                nodes: [],
              },
            ],
          },
        ],
        petroleum_geology: [
          {
            key: "11XlUTem2FCKb1GpB23mI47BMwCrhkh87",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1BXJs5_R-4RITRtLdYQSXqmQbwmXDR__e",
                gd_id: "1BXJs5_R-4RITRtLdYQSXqmQbwmXDR__e",
                label: "Anglais technique I",
                nodes: [],
              },
              {
                key: "1BGYnMkQuX9Jq8IrbM2EL850Fi17k398d",
                gd_id: "1BGYnMkQuX9Jq8IrbM2EL850Fi17k398d",
                label: "Méthodes d'étude des bassins sédimentaires",
                nodes: [],
              },
              {
                key: "1BM3qTXT4CFafbtW-lqjRazn0LWt6AhhG",
                gd_id: "1BM3qTXT4CFafbtW-lqjRazn0LWt6AhhG",
                label: "Géochimie organique",
                nodes: [],
              },
              {
                key: "1BKhNluxkbgi0ZrWZtuUUz0J7w2XoWCeR",
                gd_id: "1BKhNluxkbgi0ZrWZtuUUz0J7w2XoWCeR",
                label: "Mathématique I",
                nodes: [],
              },
              {
                key: "1AoXYKeWsxJ8oKMWJuaPCacp4r1_YgDCo",
                gd_id: "1AoXYKeWsxJ8oKMWJuaPCacp4r1_YgDCo",
                label: "Sédimentologie",
                nodes: [],
              },
              {
                key: "1AnQA5prI4s4QdWI8ACe3pK5mIef8ni0T",
                gd_id: "1AnQA5prI4s4QdWI8ACe3pK5mIef8ni0T",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1B8v7cf0b34MuXiM1BKfO2fdzuqFGvCN9",
                gd_id: "1B8v7cf0b34MuXiM1BKfO2fdzuqFGvCN9",
                label: "Physique du Milieux Poreux",
                nodes: [],
              },
              {
                key: "1AqsalC6Y19uzv8sg9ORFnXVE15mUQXQk",
                gd_id: "1AqsalC6Y19uzv8sg9ORFnXVE15mUQXQk",
                label: "Pétrophysique",
                nodes: [],
              },
              {
                key: "1BJgjvxXB7vXI3AcItV6yo5guv6rLwH6T",
                gd_id: "1BJgjvxXB7vXI3AcItV6yo5guv6rLwH6T",
                label: "Mécanique des fluides et des roches",
                nodes: [],
              },
              {
                key: "1BNxmT0wv4KWpQqVATE72d5v9zjFIVdVu",
                gd_id: "1BNxmT0wv4KWpQqVATE72d5v9zjFIVdVu",
                label: "Exploration des hydrocarbures",
                nodes: [],
              },
            ],
          },
          {
            key: "11TwwqY6SYp6FTLabs4wjZUy74j6HEy8o",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1An7W_31LBvk_boAJip7H3HjEEW7m4U78",
                gd_id: "1An7W_31LBvk_boAJip7H3HjEEW7m4U78",
                label: "Anglais technique II",
                nodes: [],
              },
              {
                key: "1CNxRSOD65SrVPpa5w4AG-g3Gcj8dbw-w",
                gd_id: "1CNxRSOD65SrVPpa5w4AG-g3Gcj8dbw-w",
                label: "Sortie sur terrain (une Semaine) travail et d’étude",
                nodes: [],
              },
              {
                key: "1CW8yKlW4ThEhczUi-briI_iYBHIL4E4K",
                gd_id: "1CW8yKlW4ThEhczUi-briI_iYBHIL4E4K",
                label: "Mathématique II",
                nodes: [],
              },
              {
                key: "1Cbsvh-C51OJTYz3F2LvXpuJ0H7eTKY85",
                gd_id: "1Cbsvh-C51OJTYz3F2LvXpuJ0H7eTKY85",
                label: "Géostatistique",
                nodes: [],
              },
              {
                key: "1Cp3xwHcjWLkLCt1Emz78djvvzByQ19JY",
                gd_id: "1Cp3xwHcjWLkLCt1Emz78djvvzByQ19JY",
                label:
                  "Caractérisation et développement des réservoirs pétroliers",
                nodes: [],
              },
              {
                key: "1CcZFwnJXk5InwKZBcK6APQkN12dRzRJH",
                gd_id: "1CcZFwnJXk5InwKZBcK6APQkN12dRzRJH",
                label: "Gisement",
                nodes: [],
              },
              {
                key: "1Ce_LdVimcIiNSDeyy75OvEcZybsmOF0K",
                gd_id: "1Ce_LdVimcIiNSDeyy75OvEcZybsmOF0K",
                label: "Forage",
                nodes: [],
              },
              {
                key: "1CPO50d5_YIK0ZDFokf97midpJh1LwoF_",
                gd_id: "1CPO50d5_YIK0ZDFokf97midpJh1LwoF_",
                label: "Mud logging",
                nodes: [],
              },
              {
                key: "1CXmzpYDSiUHBQzEWKP0Hzil_EBndwe-q",
                gd_id: "1CXmzpYDSiUHBQzEWKP0Hzil_EBndwe-q",
                label: "Logging",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        sedimentary_basin_geology: [
          {
            key: "1Cwi2idjEsWT5lINWfLKo5u2EnQzNH2su",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1GEk6gVtEiKX7P8sNPEc83i-7smrqZUXs",
                gd_id: "1GEk6gVtEiKX7P8sNPEc83i-7smrqZUXs",
                label: "Anglais 3",
                nodes: [],
              },
              {
                key: "1Fo3ztR6MhLzDpgiRTenrKehejDodezKq",
                gd_id: "1Fo3ztR6MhLzDpgiRTenrKehejDodezKq",
                label: "Stage",
                nodes: [],
              },
              {
                key: "1G2ibRPbMINIf_DEx_wiDzMDiFS3hj9vn",
                gd_id: "1G2ibRPbMINIf_DEx_wiDzMDiFS3hj9vn",
                label: "Géomorphologie et risques naturels",
                nodes: [],
              },
              {
                key: "1GD3VVw6edR5SRGqm3TB2Y6Ij0eYlN-Z8",
                gd_id: "1GD3VVw6edR5SRGqm3TB2Y6Ij0eYlN-Z8",
                label: "Géo informatique",
                nodes: [],
              },
              {
                key: "1FyA4d-aF17YW9YoPP5mrY4YjZ2agdWV8",
                gd_id: "1FyA4d-aF17YW9YoPP5mrY4YjZ2agdWV8",
                label: "Géostatistique",
                nodes: [],
              },
              {
                key: "1Fnn-zg9kxwia7KEfcXj2ikCcBZqUdU4j",
                gd_id: "1Fnn-zg9kxwia7KEfcXj2ikCcBZqUdU4j",
                label: "Télédétection 2",
                nodes: [],
              },
              {
                key: "1FwjMQqw8TTDjXPgJ262FW0v7IPDly0M1",
                gd_id: "1FwjMQqw8TTDjXPgJ262FW0v7IPDly0M1",
                label: "Hydrologie et hydrogéologie",
                nodes: [],
              },
              {
                key: "1FzVWqRJpi6Mrk8wQsCLn57TbV4kzYl7S",
                gd_id: "1FzVWqRJpi6Mrk8wQsCLn57TbV4kzYl7S",
                label: "Géoressources 2",
                nodes: [],
              },
              {
                key: "1G1KkoJluJOWWvX4F9FS0v13k1HP7zTnH",
                gd_id: "1G1KkoJluJOWWvX4F9FS0v13k1HP7zTnH",
                label: "Géophysique appliquée dans les bassins sédimentaires",
                nodes: [],
              },
            ],
          },
        ],
        geology_of_hydrocarbons: [
          {
            key: "1DA7-kbhVC4jRX1c98Ja9fR52fe75HLfQ",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1EbtDQMkMor1my-PSL2F0ac2TxuW2uels",
                gd_id: "1EbtDQMkMor1my-PSL2F0ac2TxuW2uels",
                label: "Ethiques et déontologie",
                nodes: [],
              },
              {
                key: "1EfY8KHkg3zJkRMTNNaCMrYD-a5Ml6XGQ",
                gd_id: "1EfY8KHkg3zJkRMTNNaCMrYD-a5Ml6XGQ",
                label: "Anglais technique III",
                nodes: [],
              },
              {
                key: "1ECzU3-fJhFclGdUudntIf9fZCNnvsMm5",
                gd_id: "1ECzU3-fJhFclGdUudntIf9fZCNnvsMm5",
                label:
                  "Séminaires relatifs aux problèmes d’exploration des hydrocarbures",
                nodes: [],
              },
              {
                key: "1EfLD47oRsj2nrj20PaYIlfOekxqUZ3G2",
                gd_id: "1EfLD47oRsj2nrj20PaYIlfOekxqUZ3G2",
                label:
                  "Application de la géostatistique dans le domaine des hydrocarbures",
                nodes: [],
              },
              {
                key: "1Ed-xFyyr-N3MzolOWLmRR8UGn-8NKXMI",
                gd_id: "1Ed-xFyyr-N3MzolOWLmRR8UGn-8NKXMI",
                label:
                  "Application des logiciels à géologie et à la géologie pétrolière",
                nodes: [],
              },
              {
                key: "1EYiCqcM6hN-ISPwNrWnm-lwe0xTyN6cC",
                gd_id: "1EYiCqcM6hN-ISPwNrWnm-lwe0xTyN6cC",
                label: "Législation et Gestion des projets",
                nodes: [],
              },
              {
                key: "1ENhq6BBXQqTEOHOzlnHQAaNkt-EnEYSH",
                gd_id: "1ENhq6BBXQqTEOHOzlnHQAaNkt-EnEYSH",
                label: "Programmation",
                nodes: [],
              },
              {
                key: "1ELMKiuNyv-l7eDVImE_w_UlGtXk90nWp",
                gd_id: "1ELMKiuNyv-l7eDVImE_w_UlGtXk90nWp",
                label: "Recherches opérationnelles",
                nodes: [],
              },
              {
                key: "1EcXHvLuQPRdu209j7eJ-rxdJ3Vr9pP8u",
                gd_id: "1EcXHvLuQPRdu209j7eJ-rxdJ3Vr9pP8u",
                label: "Economie pétrolières et gestion des entreprises",
                nodes: [],
              },
              {
                key: "1EakAGo89KacwiqNCnLSRJ3Z8GCHd-Bx8",
                gd_id: "1EakAGo89KacwiqNCnLSRJ3Z8GCHd-Bx8",
                label: "Initiation à l’ingénierie du réservoir",
                nodes: [],
              },
              {
                key: "1EEO9T1iXOLpL6zEBGcJd-Fmqon6xwYIs",
                gd_id: "1EEO9T1iXOLpL6zEBGcJd-Fmqon6xwYIs",
                label: "Récupération des hydrocarbures",
                nodes: [],
              },
            ],
          },
        ],
        hydrogeology: [
          {
            key: "1D2s7_9ISsJYayrzUsqrvjYCWvp_u5YcL",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1E9GzqL7i2ZhUxuQl7sP2whIumZnIFeMQ",
                gd_id: "1E9GzqL7i2ZhUxuQl7sP2whIumZnIFeMQ",
                label: "anglais",
                nodes: [],
              },
              {
                key: "1FRk6lpUao3Rr1rD4cpDMbHoznGGH4XyG",
                gd_id: "1FRk6lpUao3Rr1rD4cpDMbHoznGGH4XyG",
                label: "législation du travail",
                nodes: [],
              },
              {
                key: "1FQ7Uc77-aG43QilWduKB0mG5DQmvymyK",
                gd_id: "1FQ7Uc77-aG43QilWduKB0mG5DQmvymyK",
                label: "rédaction scientifiques",
                nodes: [],
              },
              {
                key: "1FgvE-wjTyyKxjRsAHgiOBqK-CRyXP_Hi",
                gd_id: "1FgvE-wjTyyKxjRsAHgiOBqK-CRyXP_Hi",
                label: "géostatistique",
                nodes: [],
              },
              {
                key: "1E3BbY74EjBBF4wUPp8WoSkYHBQasY4aO",
                gd_id: "1E3BbY74EjBBF4wUPp8WoSkYHBQasY4aO",
                label: "géochimie isotopique",
                nodes: [],
              },
              {
                key: "1E8VRf1nH9axh_aTQuv2_V_7bk58Qqi2M",
                gd_id: "1E8VRf1nH9axh_aTQuv2_V_7bk58Qqi2M",
                label: "gestion des eaux",
                nodes: [],
              },
              {
                key: "1FPuQHm86NprtMC2p_Jk1GACAwHTtDkUF",
                gd_id: "1FPuQHm86NprtMC2p_Jk1GACAwHTtDkUF",
                label: "vulnérabilité et protection des eaux",
                nodes: [],
              },
              {
                key: "1E24RNVHFgjs2WoiS33ZXdy-uNH-dqd9f",
                gd_id: "1E24RNVHFgjs2WoiS33ZXdy-uNH-dqd9f",
                label: "géologie des aquifères",
                nodes: [],
              },
              {
                key: "1FYH3c4CLOm6k5y5h2ztrYNpQh8fuk2f5",
                gd_id: "1FYH3c4CLOm6k5y5h2ztrYNpQh8fuk2f5",
                label: "hydrogéologie algérienne",
                nodes: [],
              },
            ],
          },
        ],
        petroleum_geology: [
          {
            key: "1D0JaP8FPQMfhPR3m3mxj-qbhZoOcl9qw",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1ElDFfjhvcE0Y3ax2lDCyKn3fbZX4eOUW",
                gd_id: "1ElDFfjhvcE0Y3ax2lDCyKn3fbZX4eOUW",
                label: "Récupération des hydrocarbures",
                nodes: [],
              },
              {
                key: "1Ey_03jBMR3LlwvpdFELLLBDno1lsG63c",
                gd_id: "1Ey_03jBMR3LlwvpdFELLLBDno1lsG63c",
                label: "Initiation à l’ingénierie du réservoir",
                nodes: [],
              },
              {
                key: "1Ezfy5Z1QqgE3XdQVVqzot7xo7Uyh8vW8",
                gd_id: "1Ezfy5Z1QqgE3XdQVVqzot7xo7Uyh8vW8",
                label: "Economie pétrolières et gestion des entreprises",
                nodes: [],
              },
              {
                key: "1EmidJ1lU4p2xnMDusFAV2QZZdp_y5_gG",
                gd_id: "1EmidJ1lU4p2xnMDusFAV2QZZdp_y5_gG",
                label: "Recherches opérationnelles",
                nodes: [],
              },
              {
                key: "1Eqwb4cB5n9_fLG00THOsmbyr_jOequcL",
                gd_id: "1Eqwb4cB5n9_fLG00THOsmbyr_jOequcL",
                label: "Programmation",
                nodes: [],
              },
              {
                key: "1Ey7FargTy-O6TmswbQAZ3scuHHUm87Zr",
                gd_id: "1Ey7FargTy-O6TmswbQAZ3scuHHUm87Zr",
                label: "Législation et Gestion des projets",
                nodes: [],
              },
              {
                key: "1F0xj2wfuFD-pN680cn2cqRyfDeLDB5ml",
                gd_id: "1F0xj2wfuFD-pN680cn2cqRyfDeLDB5ml",
                label:
                  "Application des logiciels à géologie et à la géologie pétrolière",
                nodes: [],
              },
              {
                key: "1FJAXgjQifqvXFD_cuNMEgovPUSe3L_2l",
                gd_id: "1FJAXgjQifqvXFD_cuNMEgovPUSe3L_2l",
                label:
                  "Application de la géostatistique dans le domaine des hydrocarbures",
                nodes: [],
              },
              {
                key: "1GFH6I0igWuaM4NFvpoP6CIIPZW9uxSjc",
                gd_id: "1GFH6I0igWuaM4NFvpoP6CIIPZW9uxSjc",
                label:
                  "Séminaires relatifs aux problèmes d’exploration des hydrocarbures",
                nodes: [],
              },
              {
                key: "1FPC0q0UkJbI10XQwY4j4Sue534aYpPe7",
                gd_id: "1FPC0q0UkJbI10XQwY4j4Sue534aYpPe7",
                label: "Anglais technique III",
                nodes: [],
              },
              {
                key: "1EyaLCoPG_oMZ6jPPGHhTwVzxhSDwHy81",
                gd_id: "1EyaLCoPG_oMZ6jPPGHhTwVzxhSDwHy81",
                label: "Ethiques et déontologie",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
  },
  renewable_energies: {
    licence: {
      first_year: {
        common_year: [
          {
            key: "1ehbMaKy5AXtXfSe1rCfDCqYmBnnprF4d",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1g6DG_xGZ6r5ZOXXxDnpQEjXTJ54Y5NDg",
                gd_id: "1g6DG_xGZ6r5ZOXXxDnpQEjXTJ54Y5NDg",
                label: "Langue étrangère 1",
                nodes: [],
              },
              {
                key: "1fz5kt4_0QTBNRY2awPXwO9wDq0FlM12B",
                gd_id: "1fz5kt4_0QTBNRY2awPXwO9wDq0FlM12B",
                label: "les métiers en sciences et Technologies 1",
                nodes: [],
              },
              {
                key: "1frMMzeO-hoN9a3qvadMINaW0DlNyOMae",
                gd_id: "1frMMzeO-hoN9a3qvadMINaW0DlNyOMae",
                label: "Méthodologie de la rédaction",
                nodes: [],
              },
              {
                key: "1g7z7pKbFVHkF7-4cveGGuTkNrnKSBySC",
                gd_id: "1g7z7pKbFVHkF7-4cveGGuTkNrnKSBySC",
                label: "Informatique 1",
                nodes: [],
              },
              {
                key: "1fkFA3W3ER2ZgLoSp1EntUTQz_p6eM7QN",
                gd_id: "1fkFA3W3ER2ZgLoSp1EntUTQz_p6eM7QN",
                label: "TP Chimie 1",
                nodes: [],
              },
              {
                key: "1fWn4zqYq9tDAOur03761TLB983DC5DHO",
                gd_id: "1fWn4zqYq9tDAOur03761TLB983DC5DHO",
                label: "TP Physique 1",
                nodes: [],
              },
              {
                key: "1fl3voa-Pm-Wr14Qyo3IY52e3pUjmus63",
                gd_id: "1fl3voa-Pm-Wr14Qyo3IY52e3pUjmus63",
                label: "Structure de la matière",
                nodes: [],
              },
              {
                key: "1fxMrxkf_9yPwCe5asqLyibElPvBH8EBr",
                gd_id: "1fxMrxkf_9yPwCe5asqLyibElPvBH8EBr",
                label: "Mathématique 1",
                nodes: [],
              },
              {
                key: "1fp3fesX3_ZMdqOFDQVLqPqp_vqoYBzlV",
                gd_id: "1fp3fesX3_ZMdqOFDQVLqPqp_vqoYBzlV",
                label: "Physique 1",
                nodes: [],
              },
            ],
          },
          {
            key: "1efOrWQUGMbBwm4XoiEY65ShvIXb3-WIt",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1fR80z4b2dVu9Y7nd0Q-d-R4TS0XyDdRC",
                gd_id: "1fR80z4b2dVu9Y7nd0Q-d-R4TS0XyDdRC",
                label: "Les métiers en sciences et technologies 2",
                nodes: [],
              },
              {
                key: "1fJ3u-dkTDF11KMoQ1y8LosH_brklIBjH",
                gd_id: "1fJ3u-dkTDF11KMoQ1y8LosH_brklIBjH",
                label: "Méthodologie de la rédaction 2",
                nodes: [],
              },
              {
                key: "1fUtjPDLsaqOnO-qcWcQBEMtSkDG4XIyz",
                gd_id: "1fUtjPDLsaqOnO-qcWcQBEMtSkDG4XIyz",
                label: "Anglais 2",
                nodes: [],
              },
              {
                key: "1hP4LuBbk_9Wa2pT1U8KSBpgPBcdJoM2Z",
                gd_id: "1hP4LuBbk_9Wa2pT1U8KSBpgPBcdJoM2Z",
                label: "Thermodynamique",
                nodes: [],
              },
              {
                key: "1fLnEaBqkumXbW5gefB8kSYFF8xtt3_pq",
                gd_id: "1fLnEaBqkumXbW5gefB8kSYFF8xtt3_pq",
                label: "Mathématique 2",
                nodes: [],
              },
              {
                key: "1hHh9_VZ3b8MLpKHA-44I4csC1auY3QmX",
                gd_id: "1hHh9_VZ3b8MLpKHA-44I4csC1auY3QmX",
                label: "TP Chimie 2",
                nodes: [],
              },
              {
                key: "1hCRhKTBL9WLI3mQYBhF2QUw_gPplHKD4",
                gd_id: "1hCRhKTBL9WLI3mQYBhF2QUw_gPplHKD4",
                label: "TP Physique 2",
                nodes: [],
              },
              {
                key: "1fCFJrqHQqoO4wVo--6LJFWChxnK6qRin",
                gd_id: "1fCFJrqHQqoO4wVo--6LJFWChxnK6qRin",
                label: "Physique 2",
                nodes: [],
              },
              {
                key: "1fUr6j7HXqQf796BsEs2RsYpl_4PJvbsW",
                gd_id: "1fUr6j7HXqQf796BsEs2RsYpl_4PJvbsW",
                label: "Informatique 2",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        applied_renewable_energy: [
          {
            key: "1eedtRiPPY-mtjFZ6LZ9LN5mTZMkLnBG2",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1gzbG5VR-9Goj8pJjkGuaUthFav1NeGoF",
                gd_id: "1gzbG5VR-9Goj8pJjkGuaUthFav1NeGoF",
                label: "Meterologie en ER",
                nodes: [],
              },
              {
                key: "1h7zGkbj14hnYI9J7yhPGSP4eYtMazzsF",
                gd_id: "1h7zGkbj14hnYI9J7yhPGSP4eYtMazzsF",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1h-zdR6Xxbm79FNUIwaekM-PvJpcIoVWp",
                gd_id: "1h-zdR6Xxbm79FNUIwaekM-PvJpcIoVWp",
                label: "Electricité Industrielle",
                nodes: [],
              },
              {
                key: "1gJ6LQgxfMWZpHATXqK2BjGXYAE-8ZlQW",
                gd_id: "1gJ6LQgxfMWZpHATXqK2BjGXYAE-8ZlQW",
                label: "Sciences des matériaux en Energies Renouvelables",
                nodes: [],
              },
              {
                key: "1h0juNZPN3m-vL2wCa3HB596LOTN0EUHk",
                gd_id: "1h0juNZPN3m-vL2wCa3HB596LOTN0EUHk",
                label: "Dessin technique",
                nodes: [],
              },
              {
                key: "1h-ZI4E_FHPIZIeFBJ96b_QI5HurVvPuB",
                gd_id: "1h-ZI4E_FHPIZIeFBJ96b_QI5HurVvPuB",
                label: "Logiciels de simulation des systèmes E.R",
                nodes: [],
              },
              {
                key: "1i3ppwCjLN2c04azvdwvq-PPewuU_ca7Y",
                gd_id: "1i3ppwCjLN2c04azvdwvq-PPewuU_ca7Y",
                label: "TP méthodes numériques appliquées",
                nodes: [],
              },
              {
                key: "1i7WpqiyoYnpLsSLSmSHiijJ-CsWEX44z",
                gd_id: "1i7WpqiyoYnpLsSLSmSHiijJ-CsWEX44z",
                label: "TP mécanique des fluides",
                nodes: [],
              },
              {
                key: "1gOyiww-AcJuAGyBdHGEw6hOMJRrrw4RT",
                gd_id: "1gOyiww-AcJuAGyBdHGEw6hOMJRrrw4RT",
                label: "Plan d'expériences",
                nodes: [],
              },
              {
                key: "1gDbX_HUGPSIp7Dzbrb4iB3VudBAL7BzP",
                gd_id: "1gDbX_HUGPSIp7Dzbrb4iB3VudBAL7BzP",
                label: "Thermodynamique appliquée",
                nodes: [],
              },
              {
                key: "1gwna1Jb1aYYW-6on5nKbVhTuAQNDc8yT",
                gd_id: "1gwna1Jb1aYYW-6on5nKbVhTuAQNDc8yT",
                label: "Mécanique des fluides appliquée",
                nodes: [],
              },
              {
                key: "1gJAqpnlW1kvzcu9h8xPo08A0LPBI-fe2",
                gd_id: "1gJAqpnlW1kvzcu9h8xPo08A0LPBI-fe2",
                label: "Résistance des matériaux",
                nodes: [],
              },
              {
                key: "1gjGS9smFbrijcQg2rxUHrBmUjMQDJ7pl",
                gd_id: "1gjGS9smFbrijcQg2rxUHrBmUjMQDJ7pl",
                label: "Optique physique et géométrique",
                nodes: [],
              },
              {
                key: "1gqD-bQulrThZClHHSp0qzpPDk9srcHci",
                gd_id: "1gqD-bQulrThZClHHSp0qzpPDk9srcHci",
                label: "Méthodes Numérique Appliquée",
                nodes: [],
              },
            ],
          },
          {
            key: "1ebVU0b8iwr3koHIRf7Y2ZgiLtd3dA8Tb",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1hhZen21aoMFdzN8_7Nt_muPx-Yfus-mL",
                gd_id: "1hhZen21aoMFdzN8_7Nt_muPx-Yfus-mL",
                label: "Technique d'éxpression et de communication",
                nodes: [],
              },
              {
                key: "1hof3H6oBW5qCZfFUmLcay5CEt8i2FEv2",
                gd_id: "1hof3H6oBW5qCZfFUmLcay5CEt8i2FEv2",
                label: "Réglementation et normes des Energies Renouvelables",
                nodes: [],
              },
              {
                key: "1hmVNqTU7e80GJYPWwGWGmS2_GGbOZ-ZO",
                gd_id: "1hmVNqTU7e80GJYPWwGWGmS2_GGbOZ-ZO",
                label: "Régulation et Asservissement",
                nodes: [],
              },
              {
                key: "1he4xg80MHR41Qi8qXpBOw5Esskd5cGWX",
                gd_id: "1he4xg80MHR41Qi8qXpBOw5Esskd5cGWX",
                label: "TP Résistance des matériaux",
                nodes: [],
              },
              {
                key: "1hhSpsVWuhLUOXmptUNq4RtjfAUkl9QuV",
                gd_id: "1hhSpsVWuhLUOXmptUNq4RtjfAUkl9QuV",
                label: "TP Electronique de puissance",
                nodes: [],
              },
              {
                key: "1hb0xl2ivjaPwmwUivefQx6jHGdhdI8--",
                gd_id: "1hb0xl2ivjaPwmwUivefQx6jHGdhdI8--",
                label: "TP Trensferts Thermiques",
                nodes: [],
              },
              {
                key: "1hoh_X3Hi3F7NDzvKLtbssEZSsJjG9Hml",
                gd_id: "1hoh_X3Hi3F7NDzvKLtbssEZSsJjG9Hml",
                label: "HSE Installations industrielles",
                nodes: [],
              },
              {
                key: "1hkEaCP9PkuWJ8sXUkhD-bBGKrIz4D_wZ",
                gd_id: "1hkEaCP9PkuWJ8sXUkhD-bBGKrIz4D_wZ",
                label: "Sorties Scientifiques en entreprise",
                nodes: [],
              },
              {
                key: "1hzTF99wFshvhmCM-fB6HcfRBI5a14FwS",
                gd_id: "1hzTF99wFshvhmCM-fB6HcfRBI5a14FwS",
                label: "Conversion d'Energie Renouvelables",
                nodes: [],
              },
              {
                key: "1hrpxVtcnbNwUkRH-bJW3dJLwVHNHqdpx",
                gd_id: "1hrpxVtcnbNwUkRH-bJW3dJLwVHNHqdpx",
                label: "Gisement Solaire et Eoliens",
                nodes: [],
              },
              {
                key: "1hyQJifJQM_WXDFcguZ9JmuSy9ZMpdhL9",
                gd_id: "1hyQJifJQM_WXDFcguZ9JmuSy9ZMpdhL9",
                label: "Electronique et Electrotechnique",
                nodes: [],
              },
              {
                key: "1havE6lvejbjvdT3jXgpTxZXALVfqWWvd",
                gd_id: "1havE6lvejbjvdT3jXgpTxZXALVfqWWvd",
                label: "Transfert thermique appliqué",
                nodes: [],
              },
            ],
          },
        ],
      },
      third_year: {
        applied_renewable_energy: [
          {
            key: "1eLSby1fuqUH8L8v2vNRxSrJh2wWFEMfd",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1izc0I5q15yxi-b6H90PyEA6ae8bfnrPe",
                gd_id: "1izc0I5q15yxi-b6H90PyEA6ae8bfnrPe",
                label: "Matériaux Solaires",
                nodes: [],
              },
              {
                key: "1iSqQV0rGLB4dtJIBFAQfbtewNQaiHzRA",
                gd_id: "1iSqQV0rGLB4dtJIBFAQfbtewNQaiHzRA",
                label: "TP Solaire Thermique",
                nodes: [],
              },
              {
                key: "1igL6bkdj5pY9J8ASIdV4URenx29ZUdgm",
                gd_id: "1igL6bkdj5pY9J8ASIdV4URenx29ZUdgm",
                label: "TP Photovoltaïque et éoliens",
                nodes: [],
              },
              {
                key: "1itBJX1i0cbhBTdr3n_tSiJWoHtCKIwxR",
                gd_id: "1itBJX1i0cbhBTdr3n_tSiJWoHtCKIwxR",
                label: "Métrologie en Energie Renouvelable",
                nodes: [],
              },
              {
                key: "1jZT5brUvlwx8g24gEEeClfTwe1sPpAH6",
                gd_id: "1jZT5brUvlwx8g24gEEeClfTwe1sPpAH6",
                label: "Géothermie et autres Formes d’Energies Renouvelables",
                nodes: [],
              },
              {
                key: "1jNo8aEHxOOd0lfGM9kE8xmIWGPVyztBm",
                gd_id: "1jNo8aEHxOOd0lfGM9kE8xmIWGPVyztBm",
                label: "Management de Projet d’Entreprise",
                nodes: [],
              },
              {
                key: "1jSDvFukI8IjGyBH6XI9D5q2EGhDC2z12",
                gd_id: "1jSDvFukI8IjGyBH6XI9D5q2EGhDC2z12",
                label: "Logiciels de Simulation des Systèmes d’ER",
                nodes: [],
              },
              {
                key: "1i_O4Vwhag3QEyIlIaD2L6u7ghB24eNwZ",
                gd_id: "1i_O4Vwhag3QEyIlIaD2L6u7ghB24eNwZ",
                label: "TP Régulation et Asservissement",
                nodes: [],
              },
              {
                key: "1ihmpaaEb0B62yjQ7vG2Vv7rqNV4PvNPp",
                gd_id: "1ihmpaaEb0B62yjQ7vG2Vv7rqNV4PvNPp",
                label: "Systèmes Éoliens",
                nodes: [],
              },
              {
                key: "1hRVIqqTxkp6bOuFJqoGq0JZB26gCCd5A",
                gd_id: "1hRVIqqTxkp6bOuFJqoGq0JZB26gCCd5A",
                label: "Environnement et Développement Durable",
                nodes: [],
              },
              {
                key: "1imT4wlmQGTSPkCjz745c2r9FFEfZWxF2",
                gd_id: "1imT4wlmQGTSPkCjz745c2r9FFEfZWxF2",
                label: "Stage en Enterprise",
                nodes: [],
              },
              {
                key: "1ioK8r5QzLjafgKJfL-935WdL1TSnuduB",
                gd_id: "1ioK8r5QzLjafgKJfL-935WdL1TSnuduB",
                label: "Solaire Thermique",
                nodes: [],
              },
            ],
          },
          {
            key: "1eC2DeMIle_5-GuMyOk3PbDiMnc7v_6tx",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1kDnhBwX-rmRDBjbYv568lys2y582GRuc",
                gd_id: "1kDnhBwX-rmRDBjbYv568lys2y582GRuc",
                label: "Projet de fin d'études",
                nodes: [],
              },
              {
                key: "1jwY-1CNF6Ts4EjQaqmlyvUSiaLSavuxZ",
                gd_id: "1jwY-1CNF6Ts4EjQaqmlyvUSiaLSavuxZ",
                label: "Stage Pratique",
                nodes: [],
              },
              {
                key: "1kDA1pBU-nKIErv2wOcXJFnveT-2v1gik",
                gd_id: "1kDA1pBU-nKIErv2wOcXJFnveT-2v1gik",
                label: "Projet Professionnel et Pédagogique",
                nodes: [],
              },
              {
                key: "1iMpbJ0UBED-bZmDLo7CBXoItPtyNXyLg",
                gd_id: "1iMpbJ0UBED-bZmDLo7CBXoItPtyNXyLg",
                label: "Environnement et développement durable",
                nodes: [],
              },
              {
                key: "1iFOveVl0-lU-SdBpCRTsRBoMcegTmveO",
                gd_id: "1iFOveVl0-lU-SdBpCRTsRBoMcegTmveO",
                label: "Management de Projet d'entreprise",
                nodes: [],
              },
              {
                key: "1i8E4_8_g-9DXyak1pcvI9ckAakJcW7J_",
                gd_id: "1i8E4_8_g-9DXyak1pcvI9ckAakJcW7J_",
                label: "Matériaux Solaires",
                nodes: [],
              },
              {
                key: "1jkdtBH_YTcsuA2_EIuj2ps0i6FHgIkwT",
                gd_id: "1jkdtBH_YTcsuA2_EIuj2ps0i6FHgIkwT",
                label: "TP Régulation et Asservissement",
                nodes: [],
              },
              {
                key: "1jji0I1TQSugZlEfxBt2QDfIZJ_wHXqi9",
                gd_id: "1jji0I1TQSugZlEfxBt2QDfIZJ_wHXqi9",
                label: "TP Solaire Thermique",
                nodes: [],
              },
              {
                key: "1jpTBDD1ksv1__wg9Gpayra7FPMlqIc7v",
                gd_id: "1jpTBDD1ksv1__wg9Gpayra7FPMlqIc7v",
                label: "TP Photovoltaiques et éoliens",
                nodes: [],
              },
              {
                key: "1kFO3mekasm_VQxMrYsDvenYnOUxUKLvO",
                gd_id: "1kFO3mekasm_VQxMrYsDvenYnOUxUKLvO",
                label: "Métrologie en Energies renouvelables",
                nodes: [],
              },
              {
                key: "1jzGxKwq3r38bkckwGODBSJdOemI9DU_i",
                gd_id: "1jzGxKwq3r38bkckwGODBSJdOemI9DU_i",
                label: "Stage en entreprise",
                nodes: [],
              },
              {
                key: "1iMfl1qogvZp5kTkCPCbevMJtG2EXJK8X",
                gd_id: "1iMfl1qogvZp5kTkCPCbevMJtG2EXJK8X",
                label: "Géothermie et autres formes d'énergies renouvelables",
                nodes: [],
              },
              {
                key: "1kAVRkKUAMkTbjxiHjruD5KnoQusM_kGo",
                gd_id: "1kAVRkKUAMkTbjxiHjruD5KnoQusM_kGo",
                label: "Solaire Thermique",
                nodes: [],
              },
              {
                key: "1jqi4w3RFxOK8Q9ynt6Y3fCeVuZasMjt4",
                gd_id: "1jqi4w3RFxOK8Q9ynt6Y3fCeVuZasMjt4",
                label: "Systèmes Eoliens",
                nodes: [],
              },
              {
                key: "1jq4lTnv9fs8mtGF9tpLwbnRcR313A_WA",
                gd_id: "1jq4lTnv9fs8mtGF9tpLwbnRcR313A_WA",
                label: "Systèmes Photovoltaiques",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
    master: {
      first_year: {
        renewable_energy_in_mechanics: [
          {
            key: "1e7ik-A-WYMlizshNIAmX1xE6wLnx7frk",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1lABXMheqzCpP3kbPpSAJ_UbGOWGUxAoD",
                gd_id: "1lABXMheqzCpP3kbPpSAJ_UbGOWGUxAoD",
                label:
                  "Logiciels de Simulations et de dimensionnement des installations ER",
                nodes: [],
              },
              {
                key: "1kqcj-IKai0k3E1gu1N_KIY404AI1OkEg",
                gd_id: "1kqcj-IKai0k3E1gu1N_KIY404AI1OkEg",
                label: "Thermodynamique Approfondie",
                nodes: [],
              },
              {
                key: "1jgdpnmzuqVIv3H4Y5pxm_QfdFAsQqa1v",
                gd_id: "1jgdpnmzuqVIv3H4Y5pxm_QfdFAsQqa1v",
                label: "Froid et climatisation solaire",
                nodes: [],
              },
              {
                key: "1l79z1P61gPPtsbME1HKye-lipRU_OfKG",
                gd_id: "1l79z1P61gPPtsbME1HKye-lipRU_OfKG",
                label: "MDF approfondie",
                nodes: [],
              },
              {
                key: "1ji_ny7heQhfliEmSU4q5Uk_vGkVJxv4O",
                gd_id: "1ji_ny7heQhfliEmSU4q5Uk_vGkVJxv4O",
                label: "Anglais technique",
                nodes: [],
              },
              {
                key: "1lIMhrKTscqXUb6NnhahLh-9KdhRrn740",
                gd_id: "1lIMhrKTscqXUb6NnhahLh-9KdhRrn740",
                label: "Les tours et cheminées solaires",
                nodes: [],
              },
              {
                key: "1l1M3DiWZ40SlXBWhcuArjyfmKnkEBehy",
                gd_id: "1l1M3DiWZ40SlXBWhcuArjyfmKnkEBehy",
                label: "Méthodes Numériques Appliquées",
                nodes: [],
              },
              {
                key: "1l0BHrT3wQZfIec5CNC8Q8RXvP7iBBBpf",
                gd_id: "1l0BHrT3wQZfIec5CNC8Q8RXvP7iBBBpf",
                label: "Réglementation et Normes",
                nodes: [],
              },
              {
                key: "1jhy01yjFoKr59-KPyvv8U_kUs2GX8joP",
                gd_id: "1jhy01yjFoKr59-KPyvv8U_kUs2GX8joP",
                label: "Energies Renouvelables et Enjeux énergétiques",
                nodes: [],
              },
              {
                key: "1jfAz-MtbrzyE4AhV9JKF4s_nZzr7hQ0i",
                gd_id: "1jfAz-MtbrzyE4AhV9JKF4s_nZzr7hQ0i",
                label: "Gisements Renouvelables et Météorologie",
                nodes: [],
              },
            ],
          },
          {
            key: "1diiIv1cDGSRjACFZ9u7JCqTX5WidxE0D",
            gd_id: "",
            label: "Second semester",
            nodes: [
              {
                key: "1kWk6o0wTm2F66jXTbdRuywxTIPFBmzG4",
                gd_id: "1kWk6o0wTm2F66jXTbdRuywxTIPFBmzG4",
                label: "Ethique, Déontologie et Propriété Intellectuelle",
                nodes: [],
              },
              {
                key: "1m57htS2iNYMDtwTcV-2d3vbUE79g4IyF",
                gd_id: "1m57htS2iNYMDtwTcV-2d3vbUE79g4IyF",
                label: "Système hybride CSP-gaz",
                nodes: [],
              },
              {
                key: "1m3inK2iL1-kRoMWWFs26ej5m3b5fq0us",
                gd_id: "1m3inK2iL1-kRoMWWFs26ej5m3b5fq0us",
                label: "Techniques des transferts appliqués au séchage",
                nodes: [],
              },
              {
                key: "1mcGTunvHpPZo7_V4BrSArHZCT0zamk2T",
                gd_id: "1mcGTunvHpPZo7_V4BrSArHZCT0zamk2T",
                label: "Métrologie thermique, Asservissement et Régulation",
                nodes: [],
              },
              {
                key: "1lnm7Rxhct5n-gqRdaTQ9y6EiRSWeNXyn",
                gd_id: "1lnm7Rxhct5n-gqRdaTQ9y6EiRSWeNXyn",
                label: "TP de Conversion",
                nodes: [],
              },
              {
                key: "1kJ4vktw_NhWVac89DutZLE8iefUzqhcz",
                gd_id: "1kJ4vktw_NhWVac89DutZLE8iefUzqhcz",
                label: "Montage et Dimensionnement des projets ER",
                nodes: [],
              },
              {
                key: "1kb-vjvPfq-D_BXrTnkiNeWvvKKqux0B0",
                gd_id: "1kb-vjvPfq-D_BXrTnkiNeWvvKKqux0B0",
                label: "Energie Hydro-électrique et Eolienne",
                nodes: [],
              },
              {
                key: "1mFdGoyRgXTSPq9X_ewg1msA8pqA6FFir",
                gd_id: "1mFdGoyRgXTSPq9X_ewg1msA8pqA6FFir",
                label: "Solaire Thermique et Applications",
                nodes: [],
              },
              {
                key: "1l_LTiMqEbKZIS4rqYvtaLWJeb4d_6bJw",
                gd_id: "1l_LTiMqEbKZIS4rqYvtaLWJeb4d_6bJw",
                label:
                  "Transfert Thermique Approfondie et Phénomène de Transport",
                nodes: [],
              },
              {
                key: "1maHCgD47GUT1XqRxQX0LXbWZTZnnTg4b",
                gd_id: "1maHCgD47GUT1XqRxQX0LXbWZTZnnTg4b",
                label: "Rayonnement solaire",
                nodes: [],
              },
              {
                key: "1knuFAkEkdtUbdpU6yp6Fqthqkzcekkab",
                gd_id: "1knuFAkEkdtUbdpU6yp6Fqthqkzcekkab",
                label: "Anglais technique et terminologie",
                nodes: [],
              },
              {
                key: "1kLIOhVXvkU-DSoBnHAZ-7rSrBtnu6b1j",
                gd_id: "1kLIOhVXvkU-DSoBnHAZ-7rSrBtnu6b1j",
                label: "Les tours et cheminées solaires",
                nodes: [],
              },
              {
                key: "1mQ6QXZ9qK6ONq0fVWbQJbcI8z1wEQhAy",
                gd_id: "1mQ6QXZ9qK6ONq0fVWbQJbcI8z1wEQhAy",
                label: "Réglementation et normes des ER",
                nodes: [],
              },
              {
                key: "1la6ECFGDEzSa745ITlrF4eu0An-1Ppqx",
                gd_id: "1la6ECFGDEzSa745ITlrF4eu0An-1Ppqx",
                label: "TP Méthodes Numériques Appliquées",
                nodes: [],
              },
              {
                key: "1ldkUlha8puOST8ewTd-BR_JVCqwm7Wzs",
                gd_id: "1ldkUlha8puOST8ewTd-BR_JVCqwm7Wzs",
                label: "TP Gisements Renouvelables et Météorologie",
                nodes: [],
              },
              {
                key: "1k_74avItd_J6CpQmMPMJGRSlQhy3pqJi",
                gd_id: "1k_74avItd_J6CpQmMPMJGRSlQhy3pqJi",
                label: "Energies Renouvelables et Enjeux Energétiques",
                nodes: [],
              },
              {
                key: "1kH5tET2Ho6nhwg7jnOFpo_AW8iWthECR",
                gd_id: "1kH5tET2Ho6nhwg7jnOFpo_AW8iWthECR",
                label: "Méthodes Numériques Appliquées",
                nodes: [],
              },
              {
                key: "1kPaY_fXg8aefZczT-andjmVNNIgtkkpZ",
                gd_id: "1kPaY_fXg8aefZczT-andjmVNNIgtkkpZ",
                label: "Gisements Renouvelables et Météorologie",
                nodes: [],
              },
              {
                key: "1lzzcaMsBxTlzpOIV-3Q1T8qoh0zkff3j",
                gd_id: "1lzzcaMsBxTlzpOIV-3Q1T8qoh0zkff3j",
                label: "Thermodynamique Approfondie",
                nodes: [],
              },
              {
                key: "1kIMCRmFNm7sNehmhKd4Rh_63vIZwavIU",
                gd_id: "1kIMCRmFNm7sNehmhKd4Rh_63vIZwavIU",
                label: "Mécanique des Fluides Approfondie",
                nodes: [],
              },
            ],
          },
        ],
      },
      second_year: {
        renewable_energy_in_mechanics: [
          {
            key: "1dhbHAkS-pcJOUHABoy3sXUfZtn6Vf2Kw",
            gd_id: "",
            label: "First semester",
            nodes: [
              {
                key: "1lLfEi0AbsxQsqPOKX551LxIMyhaym9ea",
                gd_id: "1lLfEi0AbsxQsqPOKX551LxIMyhaym9ea",
                label: "Etude Technico Economique et Gestion de Projets ER",
                nodes: [],
              },
              {
                key: "1lWvIk5SJR5x6QZ_CoHC2tMxwBVNiE5Vx",
                gd_id: "1lWvIk5SJR5x6QZ_CoHC2tMxwBVNiE5Vx",
                label: "Audit Énergétique",
                nodes: [],
              },
              {
                key: "1lTlxkjh3PDdpt05CuyKA-MAmtR8RlFlI",
                gd_id: "1lTlxkjh3PDdpt05CuyKA-MAmtR8RlFlI",
                label: "Efficacité Énergétique et Thermique du Bâtiment",
                nodes: [],
              },
              {
                key: "1mn3hMlaGq_XcrmH-xE3caU1onECRk_ED",
                gd_id: "1mn3hMlaGq_XcrmH-xE3caU1onECRk_ED",
                label: "Échangeurs de Chaleur",
                nodes: [],
              },
              {
                key: "1lQUDPmz13gPiOBhwVFuqNiQO-JT90Ra5",
                gd_id: "1lQUDPmz13gPiOBhwVFuqNiQO-JT90Ra5",
                label: "Energie Géothermique",
                nodes: [],
              },
              {
                key: "1nCfVbDG1kez5HuZY-XuIIgm_oPy1E3VV",
                gd_id: "1nCfVbDG1kez5HuZY-XuIIgm_oPy1E3VV",
                label: "Maintenance des Systèmes à Energies Renouvelables",
                nodes: [],
              },
              {
                key: "1nAB07861heU5UA_7JIbMkO7Lj652RALh",
                gd_id: "1nAB07861heU5UA_7JIbMkO7Lj652RALh",
                label: "Piles à Combustibles et Production de l’Hydrogène",
                nodes: [],
              },
              {
                key: "1mvGkJ43Lq0mYx26iNjmXCKpZ0M3bi1RC",
                gd_id: "1mvGkJ43Lq0mYx26iNjmXCKpZ0M3bi1RC",
                label: "Solaire Photovoltaïque et Applications",
                nodes: [],
              },
              {
                key: "1nH7-1kscBqpSpjh1ugdlaYl72TQehCc0",
                gd_id: "1nH7-1kscBqpSpjh1ugdlaYl72TQehCc0",
                label: "Fluide de Travail, Matériaux et Dispositif de Stockage",
                nodes: [],
              },
              {
                key: "1n5p4kEkq9zTWu-Sf4H4R4vEQ4A1Vs33K",
                gd_id: "1n5p4kEkq9zTWu-Sf4H4R4vEQ4A1Vs33K",
                label: "Recherche Documentaire et Conception de Mémoire",
                nodes: [],
              },
            ],
          },
        ],
      },
    },
  },
};
